export default {
  common: { loading: 'Laden…', noData: 'Geen gegevens', clear: 'Wissen', delete: 'Verwijderen' },
  errors: { /* notices-i18n */
    generic: 'Er ging iets mis. Probeer het opnieuw.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Op deze dag staat een goedgekeurde hele dag afwezigheid — er kan geen werktijd op worden geregistreerd.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Volgens je contract boek je alleen projecttijd, geen werktijd.',
      week_approved: 'Deze week is al goedgekeurd en vergrendeld – wijzigen alleen via een correctieverzoek.',
      week_submitted: 'Deze week is ingediend en wacht op een besluit – wijzigen pas nadat ze is ingetrokken of teruggestuurd.',
      already_clocked_in: 'Je bent al ingeklokt. Sluit eerst de lopende werktijd.',
      block_overlap: 'Deze werktijd overlapt met een andere.',
      block_locked: 'Deze werktijd is vergrendeld door een afgesloten week. Vraag in plaats daarvan een correctie aan.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Schakel ‘Aanmelden alleen via SSO afdwingen’ uit voordat je de issuer-URL of de Client ID wijzigt.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Een van de e-maildomeinen is geen domein. Voer domeinen in zoals example.com, zonder jokertekens of webadressen.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Dit veld is als bijzondere categorie verklaard; de verklaring kan niet worden ingetrokken.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Een veld kan niet met niets worden ingevuld.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Deze kennisgeving heeft geen veld met die naam.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Een waarde mag zelf geen openstaand veld bevatten.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Uitnodigingen zijn gepauzeerd totdat alle velden van de kennisgevingen voor medewerkers onder Juridische kennisgevingen zijn ingevuld. Vraag de workspace-eigenaar, een suite-beheerder of de functionaris gegevensbescherming om ze aan te vullen.',
      LEGAL_READINESS_UNAVAILABLE: 'We konden niet controleren of de kennisgevingen voor medewerkers compleet zijn. Probeer het over een paar minuten opnieuw.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Facturering', status: 'Status', paymentMethod: 'Betaalmethode',
    updateCard: 'Kaart vervangen', addCard: 'Kaart toevoegen',
    invoices: 'Facturen', charges: 'Betalingen',
    noInvoices: 'Nog geen facturen.', noCharges: 'Nog geen betalingen.',
    noCard: 'Geen geregistreerd', validUntil: 'geldig tot {date}',
    trialDaysLeft: 'Nog {days} dagen proefperiode', trialExpired: 'Proefperiode verlopen',
    trialDaysLeftUntil: 'Nog {days} dagen proefperiode — eindigt op {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Nog {days} dagen gratis — tot {date}',
    nextChargeOn: 'Volgende afschrijving op {date}',
    exempt: { badge: 'Vrijgesteld van facturering', note: 'lumi heeft afgesproken dat er momenteel geen kosten in rekening worden gebracht voor deze werkruimte.' },
    download: 'Downloaden', dangerZone: 'Gevarenzone',
    col: { date: 'Datum', period: 'Periode', net: 'Netto', vat: 'btw', gross: 'Bruto', status: 'Status', kind: 'Type', amount: 'Bedrag', document: 'Factuur' },
    statusLabel: { trialing: 'Proef', active: 'Actief', delinquent: 'Betaling openstaand', closed: 'Gesloten', canceled: 'Opgezegd' },
    tab: { plans: 'Abonnementen', paymentMethod: 'Betaalmethode', invoices: 'Facturen en betalingen', referral: 'Aanbevelingen', externalPostings: 'Vacatureadvertenties', dangerZone: 'Opzeggen en verwijderen' },
    externalPostings: {
      title: 'Advertenties op externe vacaturesites',
      intro: 'Advertenties op externe vacaturesites bestel je stuk voor stuk en worden per bestelling gefactureerd — tot enkele duizenden euro per stuk. Staat dit aan, dan kan iedereen wiens wervingsrol het recht ‘Extern plaatsen (betaald)’ heeft die bestellingen plaatsen — in het begin alleen de wervingsbeheerders; elke bestelling wordt aan deze workspace gefactureerd.',
      switchLabel: 'Bestellen van advertenties op externe vacaturesites toestaan',
      saving: 'Opslaan',
      offHint: 'Uitzetten stopt alleen nieuwe bestellingen. Advertenties die al lopen blijven online en worden gefactureerd tot hun looptijd afloopt.',
      offHintOpenOrders: 'Er lopen op dit moment advertenties. Uitzetten stopt alleen nieuwe bestellingen — de lopende advertenties blijven online en worden gefactureerd tot hun looptijd afloopt.',
      roleNote: 'Alleen een eigenaar van de workspace, een billing manager of een suitebeheerder kan deze instelling wijzigen. Wie geen advertenties mag bestellen, hou je tegen in de werving, door het recht ‘Extern plaatsen (betaald)’ uit diens rol te halen.',
      demoNote: 'Dit is een demo-workspace. De instellingen worden vervangen zodra je de echte inrichting doet, dus deze schakelaar blijft tot dan vergrendeld.',
      noCardTitle: 'Geen betaalmethode bekend',
      noCardBody: 'Je kunt dit nu aanzetten, maar een advertentiebestelling kan pas betaald worden als er een kaart bekend is.',
      noCardCta: 'Kaart toevoegen',
      savedOn: 'Externe advertenties staan aan. Recruiters zien het bestelgedeelte bij hun volgende paginabezoek.',
      savedOff: 'Externe advertenties staan uit. Er kunnen geen nieuwe advertenties besteld worden; advertenties die al lopen blijven online en worden gefactureerd.',
    },
    invoiceStatus: { draft: 'Wordt opgesteld', issued: 'Uitgereikt', sent: 'Verzonden', canceled: 'Geannuleerd' },
    chargeKind: { subscription: 'Abonnement', proration: 'Naar rato', posting: 'Vacature', recovery: 'Nabetaling' },
    posting: { orderRef: 'Bestelling {ref}', invoice: 'Factuur downloaden' },
    chargeStatus: { created: 'Aangemaakt', pending: 'In behandeling', paid: 'Betaald', failed: 'Mislukt', authorized: 'Gereserveerd', order_placed: 'Geplaatst', capture_requested: 'Incasso aangevraagd', captured: 'Betaald', settled: 'Betaald', refunded: 'Terugbetaald', chargeback: 'Terugboeking', voided: 'Mislukt' },
    bill: { label: 'Factuur {number}', labelMany: 'Facturen {number}', unnumbered: 'Factuur wordt opgesteld', paid: 'Betaald', closed: 'Afgesloten', retry: 'Nieuwe poging', projected: 'Verwacht' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Proefperiode tot {start} · daarna 1 gratis maand tot {end} · code {code} | Proefperiode tot {start} · daarna {n} gratis maanden tot {end} · code {code}', run: 'Gratis maanden tot {end} · code {code}', discount: 'Proefperiode tot {start} · daarna 1 maand {percent} % korting op plaatsen en modules · code {code} | Proefperiode tot {start} · daarna {n} maanden {percent} % korting op plaatsen en modules · code {code}', discountRun: '{percent} % korting op plaatsen en modules tot {end} · code {code}', invoiceLine: 'Actiecode {code} −{percent} %', referralLine: 'Aanbevelingsbonus −{percent} %', referralLineCapped: 'Aanbevelingsbonus −{percent} % (begrensd)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Actiecode (optioneel)', apply: 'Toepassen', remove: 'Verwijderen', applied: '{code}: {percent} % korting op {module} voor 1 factuur | {code}: {percent} % korting op {module} voor {n} facturen', savesToday: 'De code haalt {amount} van het bedrag van vandaag af.', rateLimited: 'Te veel pogingen. Wacht een paar minuten en probeer het opnieuw.', checkFailed: 'De code kan nu niet worden gecontroleerd. Je kunt de module ook zonder code toevoegen.', notBooked: 'Er is niets geboekt – je kunt de module zonder de code toevoegen.', addedWithoutDiscount: 'De code kon niet worden toegepast, dus er is geen korting.', module: { time_tracking: 'Tijdregistratie' }, trimmed: '{code} geeft {percent} %, maar op je factuur staat al een korting – op {module} krijg je {effective} % (alle kortingen op één factuur zijn begrensd).', trimmedNothing: '{code} geeft {percent} %, maar op je factuur staat al een korting – deze code voegt op dit moment niets toe.', pending: 'We bevestigen je code nog – hij verschijnt op je volgende factuur zodra hij bevestigd is.', invoiceLine: 'Actiecode {code} −{percent} % ({module})', running: '{code}: {percent} % korting op nog 1 factuur | {code}: {percent} % korting op nog {n} facturen', reason: { unknown: 'Deze code kennen we niet. Controleer de spelling.', disabled: 'Deze code is uitgeschakeld.', notYetValid: 'Deze code is nog niet geldig.', expired: 'Deze code is verlopen.', exhausted: 'Je hebt deze code al gebruikt, of hij is op.', moduleNotEligible: 'Deze code geldt niet voor {module}.', wrongCheckout: 'Deze code is voor nieuwe aanmeldingen, niet voor het toevoegen van een module.', unavailable: 'Deze code kun je hier niet gebruiken.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Je aanbevelingscode', copy: 'Code kopiëren', copyLink: 'Afreeklink kopiëren', copied: 'Aanbevelingscode gekopieerd', linkCopied: 'Afreeklink gekopieerd', friendGets: 'Wie hem aan het begin gebruikt, betaalt de eerste maand {percent} % minder. | Wie hem aan het begin gebruikt, betaalt de eerste {n} maanden {percent} % minder.', youGet: 'Zodra dat bedrijf gaat betalen, krijg je {percent} % korting op een van je facturen. | Zodra dat bedrijf gaat betalen, krijg je {percent} % korting op {n} van je facturen.', rules: 'Meerdere bonussen tellen op — tot {ceiling} % per factuur.', rulesCapped: 'Meerdere bonussen tellen op — tot {ceiling} % per factuur, maximaal {cap} per bonus.', paused: 'Je code staat op pauze zolang er een verwijderverzoek voor je werkruimte openstaat. Zodra dat is ingetrokken, werkt de code weer.', disabled: 'Deze code is uitgeschakeld en kan niet meer worden gebruikt.', none: { trialing: 'Je krijgt een aanbevelingscode zodra je werkruimte betaalt, na de proefperiode.', free_run: 'Je krijgt een aanbevelingscode zodra de gratis maanden voorbij zijn en je werkruimte betaalt.', not_billing: 'Je krijgt een aanbevelingscode zodra je werkruimte een lopend abonnement heeft.' }, loading: 'Je aanbevelingscode wordt geladen …', error: 'Je aanbevelingscode kon nu niet worden gelezen. Probeer het later opnieuw.', list: { title: 'Je aanbevelingen', empty: 'Hier verschijnt elk bedrijf dat je code gebruikt — en wat het je oplevert.', emptyHint: 'Eerst test het, dan betaalt het, dan ligt je bonus hier klaar om te verzilveren.', since: 'Aanbeveling van {date}', pill: { testing: 'Test nog', paying: 'Betaalt', ready: 'Klaar', running: 'Loopt {x}/{y}' }, invoices: '1 factuur | {n} facturen', sentence: { testing: 'Je bonus komt zodra het bedrijf gaat betalen.', paying: 'Het bedrijf betaalt sinds {date} — je bonus is onderweg.', ready: 'Het bedrijf betaalt sinds {date} — je krijgt {percent} % korting op {invoices}{cap}.', readyCap: ', maximaal {cap} per factuur', startsOn: 'Je bonus begint met je factuur van {date}.', startsNext: 'Je bonus begint met je volgende factuur.', waits: 'Je bonus wacht op ruimte op een komende factuur.', carried: '{months} was de eerste factuur | {months} waren de eerste facturen', nextLast: 'de laatste is die van {date}', nextThen: 'de volgende is die van {date}, daarna nog een | de volgende is die van {date}, daarna nog {n}', toCome: 'nog een te gaan | nog {n} te gaan', done: 'Het bedrijf betaalt sinds {date} — je bonus gold voor {months}.', doneNone: 'Het bedrijf betaalt sinds {date} — je bonus is opgebruikt.' }, done: { line: '1 afgeronde aanbeveling — die leverde je {percent} % korting op {invoices} op | {n} afgeronde aanbevelingen — elke leverde je {percent} % korting op {invoices} op', lineMixed: '1 afgeronde aanbeveling | {n} afgeronde aanbevelingen', show: 'Tonen', hide: 'Verbergen' }, carries: { items: 'Je volgende factuur van {date} bevat {items}.', itemsNoDate: 'Je volgende factuur bevat {items}.', none: 'Je volgende factuur van {date}: zonder korting.', noneNoDate: 'Je volgende factuur: zonder korting.', readyNote: 'Verzilverd betekent: vanaf deze factuur.' } }, bonus: { collect: 'Verzilveren', capped: 'begrensd', running: { promo: '{percent} % actiecode', module: '{percent} % modulecode', referral: '{percent} % aanbevelingsbonus' }, collected: 'Verzilverd — de bonus gaat nu van je volgende facturen af.', alreadyRunning: 'Deze bonus loopt al.', collectFailed: 'De bonus kon nu niet worden verzilverd. Probeer het opnieuw.', hint: { lead: 'Nog niet.', tail: '— de bonus wacht hier, er gaat niets verloren.', ceiling: 'Je volgende factuur bevat al {running}, en met deze bonus zou ze boven de grens van {ceiling} % uitkomen', ceilingRunning: 'Je volgende factuur bevat al {running}, waardoor er geen ruimte is voor deze bonus', ceilingLimit: 'Met deze bonus zou je volgende factuur boven de grens van {ceiling} % uitkomen', ceilingPlain: 'De kortingen op je volgende factuur laten geen ruimte voor deze bonus', roomNext: 'Een lopende bonus eindigt met je volgende factuur', roomLater: 'De eerste lopende bonus eindigt na nog {n} facturen', notActive: 'Je werkruimte is op dit moment niet actief', deletion: 'Er staat een verwijderverzoek open voor je werkruimte', unavailable: 'Of deze bonus kan worden verzilverd, is nu niet te controleren; probeer het zo meteen opnieuw' } } },
    errors: { setupFailed: 'Kaartinstelling mislukt.', loadFailed: 'Kan factureringsgegevens niet laden.', ownerOnly: 'Alleen de eigenaar van de werkruimte kan de facturering beheren.', planChangeFailed: 'Kon je abonnement niet wijzigen. Probeer het opnieuw.', paymentStanding: 'Los je openstaande betaling op voordat je upgradet.', cardRequired: 'Voeg een geldige kaart toe voordat je upgradet.', addModuleFailed: 'Kon de module niet toevoegen. Probeer het opnieuw.', cancellationPending: 'Je abonnement loopt binnenkort af. Kies eerst “Abonnement behouden” en voeg de module daarna toe.', removeFailed: 'Kon de verwijdering niet plannen. Probeer het opnieuw.' },
    retry: 'Opnieuw proberen',
    common: { close: 'Sluiten' },
    card: {
      label: 'Kaart', title: 'Betaalmethode',
      remove: 'Kaart verwijderen', removed: 'Kaart verwijderd.',
      inUse: 'Deze kaart is al gefactureerd en kan alleen worden vervangen, niet verwijderd.',
      removeConfirmTitle: 'Kaart verwijderen?', removeConfirmBody: 'Hiermee verwijder je de geregistreerde kaart. Je kunt op elk moment een nieuwe toevoegen.',
      removeError: 'Kon de kaart niet verwijderen.',
      handoff: 'Een betaallink naar iemand anders sturen', handoffTitle: 'Betaallink',
      handoffHint: '"Kaart toevoegen/vervangen": je voert de kaartgegevens zelf in. "Een betaallink naar iemand anders sturen": stuur een eenmalige link naar degene die de kaart instelt, bijv. je boekhouding.',
      handoffBody: 'Deel deze eenmalige link met degene die de kaart instelt. De link verloopt op {date}.',
      copy: 'Kopiëren', copied: 'Gekopieerd', handoffCopied: 'Betaallink gekopieerd', handoffError: 'Kon geen betaallink aanmaken.',
    },
    recovery: {
      title: 'Betaling openstaand · {amount}',
      body: 'Je bank moet deze betaling bevestigen. Bevestig hem nu om je toegang te behouden.',
      cta: 'Betaling bevestigen',
      paid: 'Betaling ontvangen – je toegang is hersteld.',
      failed: 'De betaling is niet voltooid. Je kunt het op elk moment opnieuw proberen.',
      checking: 'We controleren de betaling nog…',
      startError: 'De betaling kon nu niet worden gestart. Probeer het zo meteen nog eens.',
    },
    plan: {
      title: 'Abonnement en modules', subtitle: 'Beheer het abonnement voor elke actieve module.',
      currentPlan: 'Huidig abonnement', current: 'Huidig',
      perMonth: '{amount}/mnd', perUserMonth: '{amount} per gebruiker/mnd', perApprenticeMonth: '{amount} per leerling/mnd', volumeHint: 'Volumekorting: grotere workspaces betalen automatisch minder per plaats.',
      perUpgradeMonth: '{amount} per uitbreiding/mnd',
      upgrade: 'Upgraden', downgrade: 'Downgraden', apply: 'Abonnement wijzigen',
      downgradeNote: 'Downgrades gaan in aan het begin van je volgende factureringsperiode.',
      fixCardCta: 'Betaalmethode herstellen',
      enterprise: { title: 'Meer nodig?', body: 'Grotere teams en maatwerkvoorwaarden regel je met ons team.', cta: 'Contact met sales' },
      provisioning: 'Wordt ingesteld — dit kan een minuut duren.',
      provisioningFailed: 'Instellen mislukt — we zijn ermee bezig.',
      removeModule: 'Module verwijderen', removeConfirmTitle: 'Module verwijderen?',
      removeConfirmBody: '{module} wordt aan het einde van je huidige factureringscyclus verwijderd. Tot dan kun je dit ongedaan maken.',
      removeScheduled: 'Verwijdering van {module} gepland.',
      addTitle: 'Module toevoegen', addSubtitle: 'Breid je werkruimte uit met nog een module.',
      addCta: 'Module toevoegen', addConfirmTitle: 'Module toevoegen?',
      moduleLabel: 'Module', planLabel: 'Abonnement',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Prijs', seats: 'Plaatsen', monthly: 'Per maand', from: 'vanaf {date}' },
      apprenticeSeats: 'Geboekte leerlingplaatsen',
      apprenticeSeatsHint: 'Minimaal 1 leerlingplaats voor de opleidingsmodule.',
      apprenticeSeatsCeiling: 'Boven {max} leerlingplaatsen is er geen selfservice-tarief – dat spreken we rechtstreeks met je af:',
      apprenticeSeatAdjustment: 'Je had {booked} leerlingplaatsen geboekt voordat deze module werd verwijderd, dus is deze opnieuw toegevoegd met {booked} in plaats van de {requested} die je had aangevraagd. Je kunt ze verlagen vanaf je volgende afschrijving.',
      added: '{module} toegevoegd.',
      addedPaymentRetrying: '{module} is toegevoegd en klaar voor gebruik. We konden de betaling nu niet innen — we proberen het automatisch opnieuw.',
      alreadyActive: '{module} zit al in je abonnement.',
    },
    seats: {
      title: 'Geboekte plaatsen',
      userSeats: 'Gebruikersplaatsen', apprenticeSeats: 'Leerlingplaatsen',
      stepUp: 'Meer plaatsen', stepDown: 'Minder plaatsen',
      bookMore: 'Extra plaatsen boeken',
      confirmTitle: 'Extra plaatsen boeken?', confirmCta: 'Plaatsen boeken',
      chargeNote: 'Extra plaatsen boeken brengt een pro-rata bedrag in rekening voor de rest van deze factureringsperiode.',
      confirmTitleDecrease: 'Geboekte plaatsen verlagen?',
      reduceCta: 'Plaatsen verlagen',
      decreaseNote: 'Vandaag wordt niets in rekening gebracht of terugbetaald — je boeking verandert op {date}.',
      decreaseNoteImmediate: 'Er wordt niets in rekening gebracht of terugbetaald — je boeking verandert meteen.',
      decreaseScheduled: 'Verlaging van plaatsen gepland voor {date}.',
      mixedDirection: 'Boek extra plaatsen en verlaag plaatsen in aparte stappen: extra plaatsen worden vandaag berekend, verlaagde plaatsen gaan in bij je volgende factuur.',
      belowUsage: 'Je werkruimte gebruikt meer plaatsen dan dat. Houd er minstens {count}.',
      usageCheckUnavailable: 'We konden nu niet controleren hoeveel plaatsen in gebruik zijn. Probeer het zo meteen opnieuw.',
      leaveFreelancer: 'Hiermee verlaat je de freelancemodus.',
      returnFreelancer: 'Hiermee ga je terug naar de freelancemodus — één persoon, één plaats.',
      booked: 'Je geboekte plaatsen zijn bijgewerkt.',
      bookedPaymentRetrying: 'Je plaatsen zijn geboekt en klaar voor gebruik. We konden de betaling nu niet innen — we proberen het automatisch opnieuw.',
      bookFailed: 'De plaatsen konden niet worden geboekt. Probeer het opnieuw.',
    },
    seatPanel: {
      inUse: '{used} van {booked} in gebruik',
      bookedOnly: '{booked} geboekt',
      useUnknown: 'We konden nu niet lezen hoeveel er in gebruik zijn.',
      manage: 'Plaatsen beheren',
      pendingUsers: 'De gebruikersplaatsen gaan op {date} naar {target} — tot dan zijn er {current} geboekt.',
      pendingApprentices: 'De leerlingplaatsen gaan op {date} naar {target} — tot dan zijn er {current} geboekt.',
      reflooredUsers: 'Je verlaging naar {requested} gebruikersplaatsen is doorgevoerd op {booked}: er zitten {used} mensen in deze workspace en iedereen bezet een plaats. Verwijder de mensen die je niet meer nodig hebt en verlaag daarna opnieuw.',
      reflooredApprentices: 'Je verlaging naar {requested} leerlingplaatsen is doorgevoerd op {booked}: er lopen {used} leertrajecten. Rond de trajecten af die je niet meer nodig hebt en verlaag daarna opnieuw.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Leerlingen uit de demodata bezetten geen geboekte plaatsen: ze tellen hier niet mee en verdwijnen zodra je de demo omzet.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Wat deze boeking kost',
      includes: 'Wat je boeking bevat en wat het per maand kost.',
      userSeatsCount: '{count} gebruikersplaatsen',
      apprenticeSeatsCount: '{count} leerlingplaatsen',
      aiQuotaUpgradesCount: '{count} × uitbreiding',
      subtotal: 'Subtotaal',
      volumeDiscount: 'Volumekorting',
      monthlyTotal: 'Maandtotaal',
      currentTotal: 'Nu betaal je {amount} per maand.',
      newMonthlyTotal: 'Vanaf je volgende factuur: {amount} per maand.',
      netNote: 'Prijzen zijn exclusief btw. Extra plaatsen boeken kost daarnaast eenmalig een bedrag naar rato voor de rest van de huidige factuurperiode.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'AI-quotum',
      usageLink: 'Waaraan het wordt besteed',
      ownKey: 'Deze workspace gebruikt lumi met een eigen sleutel van een AI-aanbieder en heeft daarom geen AI-quotum — je aanbieder rekent elk token rechtstreeks met je af.',
      suspended: 'Het AI-quotum is gepauzeerd zolang deze workspace geschorst is.',
      unlimited: 'Voor deze workspace geldt geen AI-quotum — lumi heeft de limiet opgeheven.',
      intro: 'lumi, de AI-functies van alle modules en de externe AI-agents die leden koppelen delen één quotum: tot {limit} tokens per factureringsperiode. Het wordt aan het begin van elke factureringsperiode opnieuw ingesteld; ongebruikte tokens vervallen.',
      included: 'Inbegrepen',
      includedDerived: 'bij je geboekte plaatsen',
      includedOverride: 'door lumi voor deze workspace vastgesteld',
      tokensValue: '{tokens} tokens per periode',
      upgrades: 'Quotumuitbreidingen',
      upgradesNone: 'Geen geboekt',
      upgradesValue: '{count} geboekt · +{tokens} tokens',
      used: 'Gebruikt in deze periode',
      usedValue: '{used} van {limit} tokens',
      usedNoLimit: '{used} tokens tot nu toe',
      resetsOn: 'Wordt op {date} opnieuw ingesteld',
      stepPrice: 'Eén uitbreiding voegt {tokens} tokens per factureringsperiode toe voor {amount} per maand.',
      stepUp: 'Eén uitbreiding meer',
      stepDown: 'Eén uitbreiding minder',
      removeCta: 'Verwijderen op de volgende factuurdatum',
      confirmTitle: 'Een uitbreiding van het AI-quotum toevoegen?',
      confirmTitleDecrease: 'Een uitbreiding van het AI-quotum verwijderen?',
      confirmCta: 'Uitbreiding boeken',
      trialWarning: 'Dit kost echt geld, ook tijdens je proefperiode: vandaag wordt je kaart naar rato belast voor de rest van de proefperiode, voor maximaal één maand, en daarna elke maand.',
      cardRequired: 'Voor een uitbreiding van het AI-quotum heb je een actieve kaart nodig, ook tijdens de proefperiode. Voeg eerst je kaart toe — zodra die bevestigd is, kun je de uitbreiding boeken.',
      promoExcluded: 'Je code geldt niet voor het AI-quotum: een uitbreiding krijgt nooit korting en wordt tegen de lijstprijs berekend.',
      chargeNote: 'Een uitbreiding brengt een pro-rata bedrag in rekening voor de rest van deze factureringsperiode en gaat direct in.',
      decreaseNote: 'Vandaag wordt niets in rekening gebracht of terugbetaald. Je houdt de uitbreiding tot {date}; daarna geldt het kleinere quotum.',
      decreaseNoteGeneric: 'Vandaag wordt niets in rekening gebracht of terugbetaald — de uitbreiding stopt op je volgende factuurdatum.',
      newQuota: 'Daarna: tot {limit} tokens per factureringsperiode.',
      changeDelta: '{tokens} tokens · {amount} / maand',
      addCtaPrice: 'Quotumuitbreiding toevoegen · {amount} / maand',
      booked: 'Je uitbreidingen van het AI-quotum zijn bijgewerkt.',
      bookedPaymentRetrying: 'Je uitbreiding van het AI-quotum is geboekt en gaat direct in. We konden de betaling nu niet innen — we proberen het automatisch opnieuw.',
      decreaseScheduled: 'De uitbreiding van het AI-quotum stopt op {date}.',
      pending: 'De quotumuitbreidingen gaan op {date} naar {target} — tot dan zijn er {current} geboekt.',
      bookFailed: 'De uitbreidingen van het AI-quotum konden niet worden gewijzigd. Probeer het opnieuw.',
    },
    scheduled: {
      resizeTo: 'Overschakelen naar {plan}', remove: 'Module verwijderen',
      effective: 'ingaand op {date}', revert: 'Ongedaan maken', reverted: 'Geplande wijziging ongedaan gemaakt.',
    },
    proration: {
      title: 'Abonnementswijziging bevestigen', stepFrom: 'Huidig', stepTo: 'Nieuw',
      chargeNote: 'Nu upgraden brengt een pro-rata bedrag in rekening voor de rest van deze factureringsperiode.',
      freeNote: 'Deze wijziging gaat direct in zonder extra kosten tijdens je proefperiode.',
      confirm: 'Bevestigen en upgraden', cancel: 'Annuleren',
      charged: '{amount} in rekening gebracht.', appliedImmediate: 'Je nieuwe abonnement is actief.',
      appliedScheduled: 'Gepland — ingaand op {date}.',
      calculating: 'We berekenen het exacte bedrag…',
      chargeExact: 'Vandaag wordt {amount} in rekening gebracht.',
      noChargeToday: 'Vandaag wordt er niets in rekening gebracht.',
    },
    profile: {
      title: 'Factureringsgegevens', subtitle: 'Vul je factuurgegevens in om de betaling te activeren.',
      legalName: 'Wettelijke bedrijfsnaam', addressLine1: 'Adres', addressLine2: 'Adresregel 2',
      postalCode: 'Postcode', city: 'Plaats', vatId: 'btw-nummer',
      vatOptional: 'Optioneel — vereist voor verlegde btw binnen de EU.',
      save: 'Gegevens opslaan', edit: 'Factureringsgegevens bewerken', error: 'Kon je factureringsgegevens niet opslaan.',
      saved: 'Factureringsgegevens opgeslagen.',
      vatPending: 'We konden je btw-nummer op dit moment niet verifiëren. Probeer het zo dadelijk opnieuw.',
      vatInvalid: 'Dit btw-nummer kon niet worden gevalideerd. Controleer het.',
      vatRequired: 'Voor jouw land is een geldig btw-nummer vereist voordat je een kaart toevoegt.',
      completeFirst: 'Vul je factureringsgegevens in voordat je een kaart toevoegt.',
    },
    cancel: {
      title: 'Abonnement opzeggen',
      body: 'Zeg je abonnement op. Je werkruimte blijft actief tot het einde van de huidige factureringsperiode.',
      reason: 'Reden (optioneel)', confirm: 'Abonnement opzeggen', confirmTitle: 'Abonnement opzeggen?',
      confirmBody: 'Je abonnement eindigt op {date}. Tot dan blijft alles werken.',
      note: 'Tot dan blijft alles werken, ook de export van de hele werkruimte. Daarna wordt de werkruimte gesloten; de gegevens blijven nog een tijd bewaard en de eigenaren horen het voordat er iets wordt verwijderd. Moet de werkruimte eerder weg, gebruik dan „{deletion}”.',
      pending: 'Opzegging gepland — je abonnement eindigt op {date}.', pendingNoDate: 'Opzegging gepland.',
      revert: 'Abonnement behouden', error: 'Kon je abonnement niet opzeggen.',
      done: 'Opzegging gepland. Je werkruimte blijft actief tot het einde van de huidige factureringsperiode.', revertDone: 'Opzegging ongedaan gemaakt. Je abonnement loopt gewoon door.',
    },
    deletion: {
      title: 'Werkruimte verwijderen (AVG)',
      body: 'Vraag definitieve verwijdering aan van deze werkruimte en alle bijbehorende gegevens. Na een korte respijtperiode kan dit niet ongedaan worden gemaakt.',
      request: 'Verwijdering aanvragen', reason: 'Reden (optioneel)',
      confirmTitle: 'Verwijdering van werkruimte aanvragen?',
      confirmBody: 'Alle gegevens worden na een korte respijtperiode definitief gewist. Dit kan niet ongedaan worden gemaakt.',
      pending: 'Verwijdering aangevraagd — gegevens worden gewist na {date}.', pendingNoDate: 'Verwijdering aangevraagd en in behandeling.',
      cancel: 'Verwijderingsverzoek annuleren', error: 'Kon je verwijderingsverzoek niet indienen.',
      requested: 'Verwijdering aangevraagd. We wissen je werkruimte na de respijtperiode.', canceled: 'Verwijderingsverzoek ingetrokken. Je werkruimte blijft bestaan.',
      confirmType: 'Typ de naam van de werkruimte ({name}) om te bevestigen',
      cancelConfirmTitle: 'Verwijderingsverzoek intrekken?',
      cancelConfirmBody: 'Je werkruimte en alle gegevens blijven behouden. Je kunt verwijdering op elk moment opnieuw aanvragen.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Werving', time_tracking: 'Tijd', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Per gebruiker', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Per gebruiker', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Per leerling', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Per gebruiker', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Uitbreiding AI-quotum (+1.000.000 tokens per factureringsperiode)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Deze werkruimte is vrijgesteld van facturering', body: 'lumi heeft afgesproken dat er voor deze werkruimte geen kosten in rekening worden gebracht. Daarom is er geen factureringsaccount en wordt er nu en later niets in rekening gebracht. Alleen lumi kan dat wijzigen; hier valt niets in te stellen.' },
      demo: { title: 'Facturatie is niet beschikbaar in de demomodus', body: 'Deze werkruimte draait op demogegevens, dus er valt nog niets te factureren. Facturatie kan worden ingesteld zodra je de demo omzet naar een echte inrichting — de demobanner boven aan de pagina start dat.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'Het instellen van de facturatie is niet afgerond', buyerBody: 'Je aanmelding is niet afgerond, daarom heeft deze werkruimte nog geen factuuraccount en wordt er niets in rekening gebracht. Je kunt het zelf afronden: ga terug naar het afrekenen en bestel dezelfde modules opnieuw — deze werkruimte gaat dan verder waar hij gebleven was in plaats van dat er een tweede komt. Lukt het dan nog niet, neem contact op, dan maken we het samen af.', otherBody: 'Je aanmelding is niet afgerond, daarom heeft deze werkruimte nog geen factuuraccount en wordt er niets in rekening gebracht. Alleen degene die deze werkruimte heeft aangemeld kan het afronden, door terug te gaan naar het afrekenen en dezelfde modules opnieuw te bestellen. Vraag die persoon erom, of neem contact op, dan maken we het samen af.', checkoutCta: 'Terug naar afrekenen', cta: 'Contact opnemen met support' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Contractdocumenten',
      terms: 'Algemene voorwaarden',
      avv: 'Verwerkersovereenkomst (AVV)',
      tom: 'Technische en organisatorische maatregelen (TOM)',
      subprocessors: 'Subverwerkers',
    },
  },
  login: {
    ssoApple: 'Inloggen met Apple',
    passkeySignIn: 'Inloggen met een passkey',
    passkeySigningIn: 'Bezig met inloggen…',
    passkeyFailed: 'Inloggen met passkey is mislukt. Probeer het opnieuw of gebruik uw wachtwoord.',
    title: 'lumi-HR Suite',
    subtitle: 'Log in om door te gaan',
    email: 'E-mail',
    emailPlaceholder: "naam{'@'}bedrijf.nl",
    password: 'Wachtwoord',
    passwordPlaceholder: 'Je wachtwoord',
    signIn: 'Inloggen',
    signingIn: 'Bezig met inloggen…',
    failed: 'Inloggen mislukt',
    forgotPassword: 'Wachtwoord vergeten?',
    lostPhone: 'Telefoon kwijt?',
    orContinueWith: 'of ga verder met',
    ssoGoogle: 'Inloggen met Google',
    ssoMicrosoft: 'Inloggen met Microsoft',
    ssoEnterprise: 'Inloggen met bedrijfs-SSO',
    ssoOnly: 'Inloggen op deze werkruimte verloopt via de SSO van je bedrijf.',
    adminLogin: 'Inloggen als beheerder',
    ssoError: 'SSO-inloggen mislukt. Probeer het opnieuw.',
    ssoSeatLimit: 'Deze workspace heeft geen vrije gebruikersplaats, dus we konden geen account voor je aanmaken. Vraag de workspace-eigenaar of een Billing Manager om een extra plaats te boeken — opnieuw inloggen helpt pas daarna.',
    ssoLinkRequired: 'Deze bedrijfsaanmelding kon niet automatisch aan je lumi-account worden gekoppeld. Meld je op een andere manier aan en koppel de bedrijfsaanmelding daarna onder Account en beveiliging.',
    ssoEmployeeNoticeIncomplete: 'Deze workspace is nog niet klaar: de kennisgevingen voor medewerkers hebben nog openstaande velden. Vraag de workspace-eigenaar, een suite-beheerder of de functionaris gegevensbescherming om ze in te vullen in de sectie Juridische kennisgevingen — opnieuw inloggen helpt pas daarna.',
    ssoLegalReadinessUnavailable: 'We konden op dit moment niet controleren of deze workspace klaar is. Probeer het over een paar minuten opnieuw.',
    ssoOperatorPasswordOnly: 'Systeembeheerdersaccounts melden zich aan met hun wachtwoord en authenticator-app, niet via deze provider.',
    mfaTitle: 'Voer je authenticatiecode in',
    mfaIntro: 'Dit is een systeembeheerdersaccount. Voer de 6-cijferige code uit je authenticator-app in, of een van je herstelcodes.',
    mfaCode: 'Code',
    mfaSubmit: 'Aanmelden',
    mfaBack: 'Terug',
    mfaInvalid: 'Deze code is niet juist.',
    mfaReused: 'Deze code is al gebruikt. Wacht op de volgende in je app.',
    mfaExpired: 'Deze aanmelding is verlopen. Meld je opnieuw aan met je wachtwoord.',
    mfaEnrolOnConsole: 'Voor dit systeembeheerdersaccount is nog geen authenticator-app ingesteld. Stel die eerst in door je aan te melden bij de lumi-console.',
    tenantLogoAlt: 'Logo van de werkruimte',
    poweredBy: 'Mogelijk gemaakt door',
  },
  loginBranding: {
    nav: 'Inlogpagina',
    title: 'Inlogpagina',
    intro: 'Geef de inlogpagina van deze werkruimte een eigen logo, kleur en achtergrondafbeelding. Iedereen die hier inlogt, ziet het.',
    retry: 'Opnieuw proberen',
    loadFailed: 'De huidige instellingen konden niet worden geladen.',
    form: {
      title: 'Weergave',
      logo: 'Logo',
      logoHint: 'PNG, JPEG, WebP of GIF, tot 2 MB. Laat leeg om het lumi-logo te behouden.',
      image: 'Achtergrondafbeelding',
      imageHint: 'Wordt achter de inlogkaart getoond. PNG, JPEG, WebP of GIF, tot 8 MB.',
      upload: 'Uploaden',
      replace: 'Vervangen',
      remove: 'Verwijderen',
      empty: 'Geen afbeelding',
      uploaded: 'Afbeelding geüpload.',
      removed: 'Afbeelding verwijderd.',
      tooLarge: 'Dat bestand is te groot.',
      wrongType: 'Alleen PNG-, JPEG-, WebP- en GIF-afbeeldingen worden geaccepteerd.',
      uploadFailed: 'De afbeelding kon niet worden geüpload. Probeer het opnieuw.',
      removeFailed: 'De afbeelding kon niet worden verwijderd. Probeer het opnieuw.',
      removeConfirm: 'De afbeelding wordt van de inlogpagina gehaald en verwijderd. Dit kan niet ongedaan worden gemaakt.',
      primaryColor: 'Primaire kleur',
      primaryColorHint: 'Kleurt de naam van de workspace, de links en de inlogknop.',
      boxColor: 'Kleur van het vak',
      boxColorHint: 'Het vak waarin het inlogformulier staat.',
      boxColorInvalid: 'Voer een hexkleur in, zoals #ffffff.',
      boxOpacity: 'Dekking van het vak',
      boxTone: 'Tekst en velden',
      boxToneHint: 'Voorgesteld op basis van de kleur van het vak. Wissel als de tekst slecht leesbaar is.',
      toneLight: 'Licht vak, donkere tekst',
      toneDark: 'Donker vak, lichte tekst',
      nothingToSave: 'Niets om op te slaan: er is niets veranderd sinds de laatste keer opslaan.',
      fixFirst: 'Corrigeer eerst het gemarkeerde veld.',
      colorPlaceholder: 'bijv. 1a2b3c',
      colorInvalid: 'Voer een hexkleur in, zoals 1a2b3c.',
      clear: 'Wissen',
      save: 'Opslaan',
      saved: 'Inlogpagina bijgewerkt.',
      discard: 'Verwerpen',
      liveNote: 'Opgeslagen wijzigingen zijn zichtbaar zodra de inlogpagina opnieuw wordt geopend.',
    },
    preview: {
      title: 'Voorbeeld',
      hint: 'Zo ziet de inlogpagina eruit met de waarden hierboven.',
      logoAlt: 'Logovoorbeeld',
    },
  },
  authFlow: {
    forgot: {
      title: 'Je wachtwoord opnieuw instellen',
      subtitle: 'We sturen je een link om het opnieuw in te stellen.',
      email: 'E-mail',
      submit: 'Link versturen',
      done: 'Als er een account met dat e-mailadres bestaat, hebben we een resetlink verstuurd.',
      backToLogin: 'Terug naar inloggen',
    },
    reset: {
      title: 'Stel een nieuw wachtwoord in',
      password: 'Nieuw wachtwoord',
      confirm: 'Wachtwoord bevestigen',
      submit: 'Wachtwoord opslaan',
      success: 'Je wachtwoord is gewijzigd. Je kunt nu inloggen.',
      goToLogin: 'Naar inloggen',
      invalid: 'Deze link is ongeldig of verlopen.',
      mismatch: 'De wachtwoorden komen niet overeen.',
      tooShort: 'Het wachtwoord moet minstens 8 tekens bevatten.',
      missingToken: 'Geen geldig token gevonden.',
    },
    invite: {
      title: 'Stel je account in',
      subtitle: 'Kies een wachtwoord om je account te activeren.',
      forTenant: 'Uitnodiging voor {tenant}',
      password: 'Wachtwoord',
      confirm: 'Wachtwoord bevestigen',
      submit: 'Account activeren',
      submitting: 'Activeren…',
      invalid: 'Deze uitnodiging is ongeldig of verlopen.',
      mismatch: 'De wachtwoorden komen niet overeen.',
      tooShort: 'Het wachtwoord moet minstens 8 tekens bevatten.',
      passkey: {
        title: 'Stel je inloggen in',
        intro: 'Je logt in bij lumi met een passkey: vingerafdruk, gezicht of pincode van je apparaat. Geen wachtwoord om te onthouden.',
        sentTo: 'Verstuurd naar {phone}',
        create: 'Passkey aanmaken',
        creating: 'Wachten op je apparaat…',
        instead: 'In plaats daarvan een passkey gebruiken',
        or: 'of',
        unsupported: 'Deze browser kan geen passkey aanmaken. Open de link op je telefoon of in een actuele browser.',
        unavailable: 'Passkeys zijn hier niet beschikbaar voor deze workspace. Neem contact op met je beheerder.',
        expired: 'Dat duurde te lang. Probeer het opnieuw.',
        alreadyRegistered: 'Dit apparaat heeft al een passkey voor lumi.',
        failed: 'De passkey kon niet worden aangemaakt. Probeer het opnieuw.',
      },
    },
    recover: {
      title: 'Telefoon kwijt?',
      subtitle: 'Vul je mobiele nummer in en we sturen je per sms een link om een nieuwe passkey in te stellen.',
      phone: 'Mobiel nummer',
      phoneHint: 'Met landcode, bijv. +31 6 12345678',
      submit: 'Link versturen',
      done: 'Als dit nummer bij een account hier hoort, hebben we er een link naartoe gestuurd. Die is 15 minuten geldig.',
      enrolTitle: 'Nieuwe passkey instellen',
      enrolSubtitle: 'Maak een passkey aan op dit apparaat. Alle andere sessies van je account worden uitgelogd.',
      create: 'Nieuwe passkey aanmaken',
      invalid: 'Deze link is ongeldig of verlopen. Vraag een nieuwe aan.',
    },
    verify: {
      verifying: 'Je e-mailadres bevestigen…',
      success: 'Je e-mailadres is bevestigd.',
      invalid: 'Deze bevestigingslink is ongeldig of verlopen.',
      backToLogin: 'Naar inloggen',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Koppelingen met AI-agents',
      hint: 'AI-clients die u in een workspace namens u laat handelen. Elke client werkt met precies uw rechten, en wat hij leest gaat naar de aanbieder van die client.',
      none: 'Er is geen AI-agent gekoppeld.',
      inWorkspace: 'in de workspace {workspace}',
      scope: {
        read: 'lezen',
        act: 'handelen met bevestiging',
        ask: 'lumi vragen',
      },
      lastUsed: 'Laatst gebruikt op {when}',
      connectedOn: 'Gekoppeld op {when}, nog niet gebruikt',
      standing: {
        label: 'Acties op mijn eigen gegevens uitvoeren zonder te vragen',
        hint: 'Geldt nooit voor gegevens van anderen of voor nadelige beslissingen.',
        notOffered: 'Voor deze koppeling is geen doorlopende toestemming mogelijk.',
        failed: 'De instelling kon niet worden gewijzigd. Probeer het opnieuw.',
      },
      rolePins: {
        notHeld: 'U hebt die rol in deze module niet meer.',
        failed: 'De rol kon niet worden gewijzigd. Probeer het opnieuw.',
      },
      disconnect: 'Ontkoppelen',
      disconnectConfirm: '‘{client}’ verliest meteen de toegang tot {workspace}. Om hem weer te gebruiken, koppelt u hem opnieuw vanuit de client.',
      disconnected: '{client} ontkoppeld.',
      disconnectFailed: 'De koppeling kon niet worden beëindigd. Probeer het opnieuw.',
    },
    passkeys: {
      removeConfirm: 'Deze passkey wordt verwijderd. Het apparaat dat hem gebruikt, kan er niet meer mee inloggen.',
      title: 'Passkeys',
      hint: 'Een passkey logt u in met uw apparaat — vingerafdruk, gezicht of pincode. Niets te onthouden en niets om te phishen.',
      none: 'Nog geen passkeys.',
      add: 'Passkey toevoegen',
      remove: 'Verwijderen',
      unnamed: 'Passkey',
      lastUsed: 'Laatst gebruikt op {when}',
      neverUsed: 'Nooit gebruikt',
      added: 'Passkey toegevoegd.',
      removed: 'Passkey verwijderd.',
      addFailed: 'De passkey kon niet worden toegevoegd. Probeer het opnieuw.',
      removeFailed: 'De passkey kon niet worden verwijderd. Probeer het opnieuw.',
      alreadyRegistered: 'Dit apparaat heeft al een passkey voor lumi.',
      lastMethod: 'U kunt uw enige inlogmethode niet verwijderen. Stel eerst een wachtwoord in of voeg een tweede passkey toe.',
      lostDevice: 'Een telefoon of ander apparaat kwijt? Verwijder de passkey ervan uit deze lijst — pas dan heeft het geen toegang meer tot uw account.',
    },
    currentPassword: 'Huidig wachtwoord',
    phone: {
      title: 'Inlognummer',
      hint: 'Uw account logt in met een passkey. Dit nummer ontvangt uw uitnodigings- en herstellinks.',
    },
    email: {
      title: 'Inlogadres',
      hint: 'Het adres waarmee u inlogt. Als u het wijzigt, verandert ook het adres dat uw workspaces van u tonen.',
      newLabel: 'Nieuw adres',
      submit: 'Wijziging aanvragen',
      pending: 'Wachten op bevestiging op {email}. Volg de link die we daarheen hebben gestuurd.',
      cancel: 'Deze wijziging annuleren',
      cancelled: 'De openstaande adreswijziging is geannuleerd.',
      sent: 'Kijk in de nieuwe mailbox. Er verandert niets tot u de link volgt.',
      refused: 'Dat adres kan niet voor dit account worden gebruikt. Een van uw workspaces staat alleen inlogadressen op eigen domeinen toe.',
      failed: 'De wijziging kon niet worden aangevraagd. Probeer het opnieuw.',
      ssoManaged: 'Uw inlogadres wordt beheerd door uw identity provider.',
    },
    password: {
      title: 'Wachtwoord',
      hint: 'Als u uw wachtwoord wijzigt, wordt u overal elders uitgelogd.',
      newLabel: 'Nieuw wachtwoord',
      confirmLabel: 'Nieuw wachtwoord herhalen',
      submit: 'Wachtwoord wijzigen',
      changed: 'Uw wachtwoord is gewijzigd. Andere apparaten zijn uitgelogd.',
      wrongCurrent: 'Het huidige wachtwoord klopt niet.',
      failed: 'Het wachtwoord kon niet worden gewijzigd. Probeer het opnieuw.',
      tooShort: 'Het nieuwe wachtwoord moet minstens 8 tekens lang zijn.',
      mismatch: 'De twee nieuwe wachtwoorden komen niet overeen.',
      ssoOnly: 'Dit account logt in via uw identity provider en heeft daarom geen wachtwoord. U kunt er een als terugval instellen — we sturen u een link.',
      sendLink: 'Stuur me een link om een wachtwoord in te stellen',
      linkSent: 'Als er voor dit account een wachtwoord kan worden ingesteld, is er een link onderweg.',
      linkFailed: 'De aanvraag kon niet worden verzonden. Probeer het opnieuw.',
    },
    confirmEmail: {
      title: 'Bevestig uw nieuwe adres',
      working: 'Bezig met bevestigen…',
      success: 'Uw inlogadres is gewijzigd. Log opnieuw in met het nieuwe adres.',
      goToLogin: 'Naar het inloggen',
      backToAccount: 'Terug naar Account & beveiliging',
      missingToken: 'Deze link is onvolledig. Open hem rechtstreeks vanuit de e-mail.',
      invalid: 'Deze bevestigingslink is ongeldig of verlopen.',
      unavailable: 'Deze wijziging kan niet meer worden toegepast. Vraag hem opnieuw aan.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Adreswijziging annuleren',
      working: 'Annuleren…',
      success: 'De wijziging is geannuleerd. U logt in met uw huidige adres.',
      goToLogin: 'Naar inloggen',
      missingToken: 'Deze link is onvolledig. Open hem rechtstreeks vanuit de e-mail.',
      invalid: 'Deze link is ongeldig of verlopen — er is geen wijziging meer om te annuleren.',
    },
    title: 'Account en beveiliging',
    identities: 'Gekoppelde inlogmethoden',
    noIdentities: 'Geen externe inlogmethoden gekoppeld.',
    unlink: 'Verwijderen',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Deze inlogmethode wordt verwijderd. Je kunt er niet meer mee inloggen op je account.',
    linkGoogle: 'Google koppelen',
    linkMicrosoft: 'Microsoft koppelen',
    linkApple: 'Apple koppelen',
    lastMethod: 'Je kunt je enige inlogmethode niet verwijderen. Stel eerst een wachtwoord in.',
    linked: 'Inlogmethode gekoppeld.',
    unlinked: 'Inlogmethode verwijderd.',
    linkFailed: 'Koppelen mislukt.',
  },
  workspace: {
    title: 'Werkruimte',
    subtitle: 'Kies een tenant en module',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Schakel naar donkere modus',
    themeLight: 'Schakel naar lichte modus',
    welcomeTitle: 'Welkom bij de werkruimte',
    welcomeSubtitle:
      'Selecteer je tenant en een applicatiemodule om te beginnen.',
    availableModules: 'Beschikbare modules',
    comingSoonSection: 'Binnenkort in lumi-HR',
    adminMode: 'Beheerdersmodus',
    aiUsage: {
      title: 'AI-gebruik',
      pageIntro: 'Of lumi beschikbaar is in deze workspace – en wat de AI deze maand heeft verbruikt.',
      loading: 'Gebruik laden…',
      remaining: '{n} resterend',
      periodLabel: 'Factureringsperiode',
      historyTitle: 'Factureringsperiodes',
      usedThisPeriod: 'Gebruikt in deze factureringsperiode',
      split: '{included} inbegrepen · +{upgrades} uit quotumuitbreidingen',
      resetsOn: 'Wordt op {date} opnieuw ingesteld',
      periodFrom: 'Factureringsperiode vanaf {date}',
      nearLimit: 'Het AI-quotum van deze factureringsperiode is bijna op. Een quotumuitbreiding onder Facturering verhoogt het direct.',
      unlimited: 'Voor deze workspace geldt geen AI-quotum.',
      ownKey: 'Deze workspace gebruikt lumi met een eigen sleutel van een AI-aanbieder en heeft daarom geen AI-quotum.',
      noUsageYet: 'Nog geen AI-gebruik in deze factureringsperiode.',
      upgradeLink: 'Een quotumuitbreiding toevoegen onder Facturering',
      modules: {
        ats: 'Werving',
        time: 'Tijd',
        time_tracking: 'Tijd',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'lumi-assistent',
        mcp: 'Externe agents',
      },
    },
    active: 'Actief',
    systemAdmin: 'Systeembeheerder',
    user: 'Gebruiker',
    admin: 'Beheer',
    comingSoon: 'Binnenkort beschikbaar',
    noTenants: 'Geen tenants beschikbaar',
    createViaCheckout: 'Een werkruimte aanmaken via het afrekenen',
    loadFailed: 'Tenants konden niet worden geladen',
    planKlein: 'Klein',
    planMedium: 'Medium',
    planEnterprise: 'Enterprise',
    retry: 'Opnieuw proberen',
    logout: 'Uitloggen',
    noAccess: 'Geen toegang',
  },
  support: {
    title: 'Supportaanvragen',
    myTickets: 'Mijn aanvragen',
    myTicketsTitle: 'Mijn supportaanvragen',
    inbox: 'Postvak',
    inboxTitle: 'Support-postvak',
    inboxSubtitle: 'Tickets uit de tenants die je ondersteunt',
    ticket: 'Ticket',
    newTicket: 'Nieuwe supportaanvraag',
    newTicketTitle: 'Nieuwe supportaanvraag',
    newTicketIntro: 'Beschrijf je probleem en we nemen contact met je op.',
    sent: 'Je aanvraag is verstuurd.',
    goToMyRequests: 'Naar mijn supportaanvragen',
    subject: 'Onderwerp',
    subjectPlaceholder: 'Korte samenvatting',
    message: 'Bericht',
    messagePlaceholder: 'Beschrijf wat er is gebeurd…',
    consentLabel: 'Ik ga ermee akkoord dat mijn gegevens worden verwerkt om dit verzoek te behandelen',
    send: 'Versturen',
    reply: 'Antwoorden',
    markComplete: 'Markeren als opgelost',
    reopen: 'Heropenen',
    replyPlaceholder: 'Schrijf een antwoord…',
    escalate: 'Escaleren',
    escalated: 'Geëscaleerd',
    deescalate: 'De-escaleren',
    deescalateBlocked: 'Voor dit ticket staat nog een supporttoegang open. Trek die eerst in en de-escaleer daarna.',
    close: 'Sluiten',
    statusLabel: 'Status',
    module: 'Module',
    tenant: 'Tenant',
    requester: 'Aanvrager',
    updated: 'Bijgewerkt',
    backToTickets: 'Terug naar mijn aanvragen',
    status: {
      open: 'Open',
      in_progress: 'In behandeling',
      answer: 'Beantwoord',
      closed: 'Gesloten',
    },
    author: {
      user: 'Jij',
      support: 'Support',
      systemAdmin: 'Systeembeheerder',
    },
    empty: {
      myTitle: 'Nog geen tickets',
      myBody: 'Wanneer je een supportticket aanmaakt, verschijnt het hier.',
      inboxTitle: 'Niets te ondersteunen',
      inboxBody: 'Je hebt op dit moment geen supporttickets in je tenants.',
      notFoundTitle: 'Ticket niet beschikbaar',
      notFoundBody: 'Dit ticket kon niet worden geladen. Mogelijk is het verwijderd of heb je geen toegang.',
    },
  },
  notifications: {
    nav: 'Meldingen',
    title: 'Meldingen',
    subtitle: 'Dingen die je aandacht nodig hebben.',
    settings: 'Instellingen',
    backToWorkspace: 'Terug naar werkruimte',
    area: 'Gebied',
    areaAll: 'Alle gebieden',
    status: 'Status',
    statusAll: 'Alle',
    statusUnread: 'Ongelezen',
    statusRead: 'Gelezen',
    perPage: 'Per pagina',
    markRead: 'Markeren als gelezen',
    markUnread: 'Markeren als ongelezen',
    markAllRead: 'Alles als gelezen markeren',
    loading: 'Laden…',
    empty: 'Je bent helemaal bij.',
    pageInfo: '{from}–{to} van {total}',
    prev: 'Vorige',
    next: 'Volgende',
    retentionHint: 'Meldingen worden 6 maanden bewaard.',
    settingsTitle: 'Meldingen per gebied configureren',
    settingsSubtitle: 'Kies hoe je per gebied op de hoogte wilt worden gehouden.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Een paar meldingen over beveiliging, geld, contracten, je werkruimte en wettelijke termijnen bereiken altijd de mensen die ze aangaan — ze verschijnen ook in de bel.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Je account heeft geen e-mailadres, dus meldingen bereiken je in de app (en als pushmelding waar je dat hebt toegestaan). ‘{mailMode}’ werkt daarom als ‘{inAppMode}’: er wordt niets per e-mail verstuurd.',
    mustReachStillReaches: 'Ook als je dit uitschakelt, ontvang je {list} nog steeds wanneer ze op jou betrekking hebben.',
    mandatoryReason: {
      billing: 'Kan niet worden uitgeschakeld: geld dat je verschuldigd bent, moet de verantwoordelijke persoon bereiken.',
      legal: 'Kan niet worden uitgeschakeld: contractwijzigingen moeten je bereiken, zoals onze voorwaarden beloven.',
    },
    mustReachFamily: {
      identity: 'beveiligingsmeldingen',
      money: 'factureringsmeldingen',
      legal: 'contractmeldingen',
      workspace: 'meldingen over de werkruimtestatus',
      privacy: 'privacy-termijnherinneringen',
      participation: 'verzoeken aan de werknemersvertegenwoordiging',
    },
    backToList: 'Terug naar meldingen',
    modeOff: 'Helemaal niet',
    modeInApp: 'Alleen in app',
    modeMailInApp: 'E-mail en in app',
    saved: 'Opgeslagen.',
    saveError: 'Opslaan is mislukt. De instelling is teruggezet.',
    openTarget: 'Open het gekoppelde item',
    opening: 'Openen…',
    openFailed: 'Deze melding kon niet worden geopend.',
    areas: {
      system: 'Systeem',
      timecard: 'Tijd',
      ats: 'Werving',
      apprentice: 'Ausbildung',
      people: 'Personeel',
      support: 'Support',
      postings: 'Vacatures',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Facturering',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Contractdocumenten',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Mijn gegevens opslaan',
      later: 'Niet nu',
      saved: 'Bedankt — je gegevens zijn opgeslagen.',
      skip: {
        title: 'Je gegevens overslaan?',
        body: 'Zolang je je gegevens niet invult, blijft je eigen dossier in Personeel onbevestigd. Dat betekent: er kunnen geen personeelsgegevens zoals contract, verlof of loon worden toegevoegd, je kunt niet als leidinggevende van iemand worden aangewezen en je staat in Personeel als „onbevestigd”. Je kunt het altijd later doen — deze herinnering komt morgen terug.',
        fill: 'Nu invullen',
        skip: 'Nu overslaan',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'lumi inrichten',
      subtitle: 'Niets hiervan is verplicht. Alles loont als je eraan toe bent.',
      hide: 'Heb ik niet meer nodig',
      viewAll: 'Bekijk alles wat lumi kan',
      rareHeading: 'Minder vaak nodig',
      page: {
        title: 'Wat lumi kan.',
        subtitle: 'Alles wat je kunt instellen. Het belangrijkste eerst, de rest wanneer je het nodig hebt.',
        tipsTitle: 'Tips op de startpagina',
        tipsShown: 'Het paneel staat bovenaan je startpagina tot je het niet meer nodig hebt.',
        tipsHidden: 'Je hebt het paneel verborgen. Hier haal je het terug.',
        emptyTitle: 'Hier valt voor jou niets in te stellen.',
        emptyBody: 'Wat je kunt instellen, wordt geregeld door de verantwoordelijken in je team. Vraag het hen als je iets mist.',
      },
      sections: {
        suite: 'Home',
        ats: 'Werving',
        time: 'Tijd',
        people: 'Personeel',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Inlogpagina vormgeven', hint: 'Logo en kleuren, zodat je team ziet dat het goed zit.' },
        portal_design: { title: 'Carrièreportaal vormgeven', hint: 'Zo zien kandidaten jullie bedrijf als eerste.' },
        email_templates: { title: 'E-mailsjablonen', hint: 'Ontvangstbevestiging, uitnodiging, afwijzing: één keer schrijven, altijd gebruiken.' },
        job_posting_settings: { title: 'Gegevens voor vacatures', hint: 'Logo en contactpersoon. Externe vacaturesites hebben beide nodig.' },
        work_time_models: { title: 'Werktijdmodellen', hint: 'Wie hoeveel uur werkt op welke dagen.' },
        company_holidays: { title: 'Bedrijfssluitingen', hint: 'Dagen waarop het bedrijf gesloten is.' },
        data_import: { title: 'Personen importeren', hint: 'Neem bestaande lijsten over in plaats van alles over te typen.' },
        company_profile: { title: 'Bedrijfsprofiel', hint: 'Adres en kerngegevens die lumi op veel plekken gebruikt.' },
        org_units: { title: 'Organisatie-eenheden', hint: 'Afdelingen en locaties waarop veel wordt gesorteerd.' },
        payroll_handover: { title: 'Loonoverdracht (DATEV)', hint: 'lumi levert de uren, je belastingadviseur berekent het loon.' },
        training_occupations: { title: 'Opleidingsberoepen', hint: 'Welke beroepen jullie opleiden.' },
        workflows: { title: 'Workflows', hint: 'Eigen stappen en goedkeuringen in het sollicitatieproces.' },
        application_forms: { title: 'Sollicitatieformulieren', hint: 'Welke vragen sollicitanten beantwoorden.' },
        offer_templates: { title: 'Aanbiedingssjablonen', hint: 'Contractaanbiedingen voorbereiden met plaatshouders.' },
        custom_fields: { title: 'Eigen velden', hint: 'Extra gegevens bij vacatures en sollicitaties.' },
        booking_types: { title: 'Boekingstypen', hint: 'Wat naast werktijd geboekt kan worden.' },
        leave_types: { title: 'Afwezigheidstypen', hint: 'Vakantie, ziekte en jullie eigen soorten.' },
        api_settings: { title: 'Koppeling (API)', hint: 'Tijden via de API doorgeven aan eigen programma’s. De loonoverdracht staat onder Personeel.' },
        time_clock: { title: 'Prikklok', hint: 'In de browser van een tablet op de werkplek openen: iedereen meldt zich daar aan met de eigen lumi-login en klokt in of uit.' },
        sso: { title: 'Single sign-on', hint: 'Aanmelden met jullie bedrijfsaccount.' },
        onboarding_templates: { title: 'Onboardingsjablonen', hint: 'Checklists voor de eerste dagen van nieuwe collega\'s.' },
        recruiting_options: { title: 'Optielijsten', hint: 'Aanhef, contracttypes en werklocaties waaruit jullie team kiest.' },
      },
    },
    greeting: { morning: 'Goedemorgen', day: 'Hallo', evening: 'Goedenavond' },
    // De datumregel onder de groet ("Maandag 21 september · Week 39",
    // workspace-start M2) vervangt de statische subtitel.
    dateLine: { week: 'Wk {n}' },
    open: 'Openen',
    recents: 'Onlangs',
    recentKinds: { report: 'Weekverslag', job: 'Vacature', application: 'Sollicitatie' },
    moreActions: 'Meer acties',
    clockedInSince: 'Ingeklokt sinds {time}',
    clockedOut: 'Uitgeklokt',
    clockOut: 'Uitklokken',
    clockIn: 'Inklokken',
    projectRunning: 'Projecttijd loopt',
    projectRunningSince: 'Sinds {time}',
    startProject: 'Project starten',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Volgens je contract boek je alleen projecttijd, geen werktijd.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Waar werk je aan?',
      none: 'Zonder project',
      noneSub: 'Telt als “Niet toegewezen”',
      choose: 'Project en activiteit kiezen',
      fieldLabel: 'Waar werk je aan? Nu: {current}',
      runningWith: '{activity} · sinds {time}',
      runningSince: 'Sinds {time}',
      activityStep: 'Welke activiteit?',
      back: 'Alle projecten',
      defaultActivity: 'Standaard',
      search: 'Project zoeken',
      noMatch: 'Geen project gevonden',
      close: 'Sluiten',
    },
    provisioning: 'Wordt ingesteld — dit kan een minuut duren.',
    preferences: 'Voorkeuren',
    seeMyOrg: 'Mijn organisatie',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Vacatures, sollicitaties en de wervingspijplijn — van het eerste cv tot het getekende contract.',
        time_tracking: 'Klokken, werktijdsaldi, verzuim en overuren, klaar voor de werktijdregistratie.',
        apprenticeship: 'Digitale opleidingsdossiers, opleidingsplannen en beoordelingen voor elke leerling.',
      },
      heading: 'Meer modules',
    },
    empty: 'Hier is nog niets — open de module om te beginnen.',
    unavailable: 'Kan op dit moment niet worden geladen.',

    goToModule: 'Ga naar {module}', expand: '{module} uitklappen', collapse: '{module} inklappen',
    themeLight: 'Licht',
    themeDark: 'Donker',
    people: { selfService: 'Mijn gegevens' },
    myDocuments: {
      title: 'Mijn documenten',
      downloadFailed: 'Downloaden mislukt – probeer het later opnieuw.',
      showAll: 'Alles tonen ({count})',
      showLess: 'Minder tonen',
      handIn: 'Document indienen',
      empty: 'Nog niets hier. Je kunt een getuigschrift, verklaring, ziekmelding of kopie van je identiteitsbewijs indienen voor je dossier.',
      kindLabel: 'Wat is het?',
      fileLabel: 'Bestand – kiezen of fotograferen',
      send: 'Versturen',
      cancel: 'Annuleren',
      handedIn: 'Ingediend op {date} · wacht op HR',
      accepted: 'Ingediend op {date} · geaccepteerd',
      sentBack: 'Teruggestuurd op {date}: “{reason}”',
      handInAgain: 'Opnieuw indienen',
      dismiss: 'Verbergen',
      error: {
        file_refused: 'Dit bestand kon niet worden geaccepteerd – probeer een ander bestand.',
        file_too_large: 'Dit bestand is te groot – de limiet is 25 MB.',
        file_empty: 'Dit bestand is leeg – kies een ander bestand.',
        file_missing: 'Kies eerst een bestand.',
        quota_exceeded: 'Je dossier heeft zijn opslaglimiet bereikt – neem contact op met HR.',
        invalid_category: 'Kies om wat voor soort document het gaat.',
        not_possible: 'Indienen is nu niet mogelijk – neem contact op met HR.',
        generic: 'Indienen mislukt – probeer het later opnieuw.',
        scan_unavailable: 'Het bestand kon nu niet worden gecontroleerd. Probeer het zo meteen opnieuw.',
      },
      category: {
        contract: 'Arbeidsovereenkomst',
        contract_amendment: 'Contractwijziging',
        certificate: 'Getuigschrift',
        attestation: 'Verklaring',
        payslip: 'Loonstrook',
        health_certificate: 'Ziekmelding / medische verklaring',
        identification: 'Identiteitsbewijs',
        other: 'Overig',
      },
    },
    admin: {
      users: 'Gebruikers',
      usersMoved: {
        title: 'Gebruikersbeheer is verhuisd naar Personeel',
        redirecting: 'Personeel wordt geopend…',
        noPeople: 'Wie toegang heeft tot deze werkruimte, beheer je bij elke persoon in Personeel. Personeel is hier niet beschikbaar voor je – neem contact op met de eigenaar van de werkruimte.',
      },
    },
    verwaltung: { heading: 'Beheer' },
    nav: { home: 'Dashboard', billing: 'Facturering', logout: 'Uitloggen', language: 'Taal', administration: 'Beheer', sso: 'Single Sign-On', audit: 'Auditlogboek', supportAccess: 'Supporttoegang', aiUsage: 'AI-gebruik', dataProcessing: 'Gegevensverwerking', dataRequests: 'Verzoeken van betrokkenen', legalNotices: 'Juridische mededelingen', statutoryRules: 'Wettelijke regels', trainingOccupations: 'Opleidingsberoepen', externalAgents: 'Externe AI-agents', setup: 'Instellen' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Deze week',
      hoursUnit: 'u',
      balance: 'Urenrekening, stand op {date}: {balance}',
      balanceHint: 'Gewerkte uren minus verschuldigde uren tot en met die dag.',
      noTarget: 'Geen weekuren vastgelegd.',
      trustBased: 'Voor jou geldt werktijd op vertrouwensbasis: je registreert wanneer je begint en stopt, en voor jou is er geen doel en geen urenrekening.',
      projectsMore: 'en nog {n}',
      days: 'Dagen van de week',
    },
    heute: {
      clock: 'Prikklok',
      attention: 'Vraagt om jou',
      news: 'Nieuw',
      leaveRemaining: 'Resterend verlof',
      days: 'Dag | Dagen',
      kind: { interview: 'Gesprek', leave: 'Afwezigheden', holiday: 'Feestdag', exam: 'Examen', station: 'Afdelingswissel' },
    },
    facts: {
      ats: { total_jobs: 'Vacatures', total_applications: 'Sollicitaties', open_tasks: 'Openstaande taken', new_applicants: 'Nieuwe kandidaten', create_job: 'Vacature aanmaken', add_application: 'Sollicitatie toevoegen', create_task: 'Taak aanmaken', pipeline: 'Pijplijn', pipeline_closed: '{n} afgesloten', stage_other: 'Overig' },
      time: { week_hours: 'Uren deze week', today_hours: 'Uren vandaag', timesheet: 'Mijn urenstaat', request_leave: 'Verlof aanvragen', approvals: 'Goedkeuringen', team: 'Team', pending_approvals: 'Openstaande goedkeuringen', leave_remaining: 'Resterend verlof', proof_open: 'Bewijs ontbreekt' },
      apprentice: { waiting: 'Te beoordelen', active: 'Leerlingen', overdue: 'Ontbrekende weken', this_week: 'Deze week', badges: 'Vaardigheden', write: 'Week invullen', skills: 'Vaardighedenmuur', review: 'Rapporten beoordelen', onboard: 'Leerling toevoegen', reports: 'Rapportboeken', report_approved: 'Goedgekeurd', report_submitted: 'Te beoordelen', report_rejected: 'Teruggestuurd', report_missing: 'Ontbreekt' },
    },
  },
  preferences: {
    appearance: 'Weergave',
    theme: 'Thema',
    themeHint: 'Licht of donker uiterlijk.',
    language: 'Taal',
    languageHint: 'De taal in de hele workspace.',
    attributions: 'Naamsvermelding open data',
    placesCredit: 'Plaatsgegevens © {source}, gelicentieerd onder {licence}.',
    bankCodesCredit: "Bankcodes: bron {bundesbank}; Oostenrijkse bankcodes © {oenb}, gelicentieerd onder {licence}; Zwitserse en Liechtensteinse bankcodes © {six}.",
    healthInsurersCredit: "Zorgverzekeraars: stambestand sociale verzekeringen van de {gkv}.",
  },
  onboarding: {
    actions: { add: 'Toevoegen', back: 'Terug', next: 'Volgende', remove: 'Verwijderen' },
    modules: {
      ats: 'Werving',
      time_tracking: 'Tijd',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Welkom bij lumi',
      title: 'Fijn dat je',
      titleMark: 'er bent.',
      subtitle: 'Hoe wil je beginnen? Je kunt altijd wisselen.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Weg uit de demo',
      titleDemo: 'Genoeg geprobeerd.',
      titleDemoMark: 'Nu echt.',
      subtitleDemo: 'Met de begeleide inrichting blijft het demobedrijf staan tot je klaar bent.',
      reassure: 'Twijfel je? Begin met de demo – naar de echte inrichting wissel je wanneer je maar wilt.',
      seedFailed: 'Het voorbereiden van de demogegevens is niet voltooid. Probeer het opnieuw.',
      seedFailedNotEmpty:
        'De demo heeft lege modules nodig, maar een van je modules bevat al gegevens. Verwijder die eerst, of kies in plaats daarvan ‘Je suite inrichten’.',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'De inrichting kan pas worden afgerond als de verwerkersovereenkomst (AVV) is geaccepteerd. Accepteer die hier, dan ga je meteen terug naar de inrichtingswizard.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Terug naar de demo',
      demo: {
        eyebrow: 'Uitproberen',
        title: 'Verkennen met demogegevens',
        body: 'We vullen je modules met één samenhangend, fictief bedrijf. Klik overal doorheen zonder iets kapot te maken.',
        modulesHint: 'Geboekte modules zijn altijd inbegrepen.',
        cta: 'Demo verkennen',
      },
      guided: {
        eyebrow: 'Inrichten',
        title: 'Leid me er stap voor stap doorheen',
        body: 'Stap voor stap naar je echte suite. Pauzeren, overslaan of eerst naar de demo – het kan allemaal.',
        bodyDemo: 'Stap voor stap naar je echte suite. Sluit je het venster, dan ben je weer terug in de demo.',
        pointSaved: 'Je tussenstand wordt opgeslagen',
        pointOptional: 'Elke stap is optioneel',
        cta: 'Leid me erdoorheen',
      },
      empty: {
        eyebrow: 'Zelf doen',
        titleFresh: 'Leeg beginnen',
        titleDemo: 'Demo verwerpen en leeg beginnen',
        bodyFresh: 'Een blanco start. Je richt alles gaandeweg zelf in, helemaal in je eigen tempo.',
        bodyDemo: 'Het demobedrijf wordt verwijderd en je begint op een lege basis.',
        warnDemo: 'Dit gebeurt direct en kan niet ongedaan worden gemaakt.',
        cta: 'Leeg beginnen',
      },
    },
    exitGate: {
      title: 'Voordat je de demo verlaat',
      intro: 'Dit heeft je werkruimte geboekt en zo staat het met je proefperiode. Voeg nu een module toe of later via Facturatie — instellen werkt in beide gevallen.',
      booked: { title: 'Geboekt' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Collega’s die je voor de demo hebt uitgenodigd',
        lead: 'Deze collega’s verliezen hun toegang als de demo eindigt:',
        fallback: 'Collega’s die je voor de demo hebt uitgenodigd, verliezen hun toegang als die eindigt.',
        people: 'Je echte team nodig je uit vanuit Personeel zodra je werkruimte is ingericht.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: '{module} wordt ingericht…',
        booked: '{module} is geboekt en heeft een eigen sectie in de installatiegids.',
        bookedPending: '{module} is geboekt. De sectie verschijnt in de installatiegids zodra de module klaar is.',
      },
      noManage: 'Alleen de eigenaar van de werkruimte, een facturatiebeheerder of een werkruimtebeheerder kan modules boeken. Je kunt wel doorgaan zonder te boeken.',
      enforcement: 'Er staat een betaling open voor deze werkruimte. Boeken is gepauzeerd totdat die is voldaan — het instellen van je suite niet.',
      factsUnavailable: 'We konden je boeking nu niet laden. Je kunt toch doorgaan; alles staat op de pagina Facturatie.',
      trial: {
        title: 'Je proefperiode',
        range: 'Je proefperiode begon op {start} en eindigt op {end}.',
        endOnly: 'Je proefperiode eindigt op {end}.',
        rangeFree: 'Gratis van {start} tot {end}.',
        endOnlyFree: 'Gratis tot {end}.',
        charge: 'Vanaf {end} wordt {amount} per maand in rekening gebracht voor wat je hebt geboekt, aan het begin van elke factuurmaand.',
        chargeNoTotal: 'Vanaf {end} wordt je boeking maandelijks in rekening gebracht, aan het begin van elke factuurmaand.',
        firstCharge: 'De eerste afschrijving is op {date}.',
        demoCounted: 'De tijd die je in de demo doorbracht, telde mee voor je proefperiode.',
        over: 'Je proefperiode is afgelopen en je boeking wordt maandelijks gefactureerd.',
        monthly: 'Dat is {amount} per maand.',
        nextCharge: 'De volgende afschrijving is op {date}.',
      },
      continue: 'Doorgaan naar instellen',
    },
    avv: {
      modalTitle: 'Verwerkersovereenkomst (AVV) accepteren',
      modalBody:
        'Als je je suite met echte gegevens inricht, verwerkt lumi namens jou persoonsgegevens. Lees en accepteer eerst onze huidige verwerkersovereenkomst (AVV) voordat je verdergaat.',
      modalLinkText: 'Volledige AVV lezen',
      modalCheckboxLabel: 'Ik heb de huidige AVV gelezen en accepteer deze.',
      modalCancel: 'Nog niet',
      modalAccept: 'Accepteren en doorgaan',
    },
    preparing: {
      first: {
        title: 'Je demo wordt voorbereid.',
        body: 'We maken een samenhangend, fictief bedrijf aan in al je modules. Dit duurt maar even.',
      },
      reset: {
        title: 'Je demo wordt gereset.',
        body: 'We maken het demobedrijf leeg en bouwen het opnieuw op. Je werkruimte en je collega’s blijven ongemoeid. Dit duurt maar even.',
      },
      stuck: {
        note: 'Dit duurt langer dan verwacht.',
        cta: 'Handmatig instellen',
      },
    },
    nonAdmin: {
      title: 'Bijna',
      titleMark: 'klaar.',
      body: 'Je beheerder is de suite nog aan het inrichten. Zodra dat klaar is, kom je hier direct binnen.',
    },
    wizard: {
      title: 'Je suite inrichten',
      subtitle: 'Alles hier is optioneel en je voortgang wordt bewaard. Stel in wat je wilt, rond de configuratie af of ga terug naar de demo door dit venster te sluiten.',
      subtitleCommitting: 'Je configuratie wordt toegepast. Mislukt een stap, dan kun je die overslaan en later in de instellingen regelen.',
      crossRef: 'Gebruikt in {modules} — later te wijzigen in {owner}.',
      crossRefOwnerDefault: 'Personeel',
      recovery: '‘{step}’ kon niet worden toegepast. Controleer daar je gegevens en rond opnieuw af.',
      details: {
        step: 'Jouw gegevens',
        title: 'Jouw gegevens',
        subtitle: 'Je eigen record in Personeel. Controleer je naam – door op te slaan bevestig je je record.',
        loading: 'Je record wordt geladen…',
        confirmed: 'Je record is bevestigd als {name}. Je kunt het later in Personeel wijzigen.',
        unavailable: 'Je record kon nu niet worden geladen. Je kunt het later in Personeel bevestigen.',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        required: 'Vul je voor- en achternaam in.',
        hq: {
          title: 'Jullie hoofdkantoor',
          why: 'Zonder locatie kan Lumi niet werken: het heeft jullie hoofdkantoor nodig als eerste locatie, bijvoorbeeld voor jullie vacatures.',
          street: 'Straat',
          postalCode: 'Postcode',
          city: 'Plaats',
          country: 'Land',
          countryNone: 'Geen land geselecteerd',
          required: 'Vul straat, postcode, plaats en land van jullie hoofdkantoor in.',
        },
      },
      general: {
        title: 'Algemeen',
        company: {
          title: 'Bedrijfsprofiel',
        },
        name: {
          label: 'Bedrijfsnaam',
          hint: 'Vooraf ingevuld vanuit de checkout — pas aan indien nodig. Verplicht.',
          required: 'Bedrijfsnaam is verplicht.',
        },
        profile: {
          industry: 'Branche',
          employeeCountRange: 'Bedrijfsgrootte',
          employeeCountPlaceholder: 'bijv. 50–200',
          foundedYear: 'Opgericht',
          foundedYearPlaceholder: 'bijv. 2010',
          legalForm: 'Rechtsvorm',
          websiteUrl: 'Website',
        },
        place: {
          hint: 'Kies een plaats uit de lijst als naam van de locatie — of typ een eigen naam en bevestig met Enter of +.',
        },
        org: {
          title: 'Organisatiestructuur',
          subtitle: 'Afdelingen, locaties en kostenplaatsen waartoe je medewerkers behoren.',
          departments: 'Afdelingen',
          locations: 'Locaties',
          costCenters: 'Kostenplaatsen',
          empty: 'Nog geen',
          addDepartment: 'Nieuwe afdeling',
          addLocation: 'Nieuwe locatie, bijv. Amsterdam',
          addCostCenter: 'Nieuwe kostenplaats',
        },
      },
      finish: {
        cta: 'Inrichting afronden',
        step: 'Afronden',
        title: 'Rond je inrichting af',
        body: 'Bij het afronden worden je antwoorden toegepast. Je kunt later alles per module wijzigen.',
        nextTitle: 'Daarna: nodig je team uit',
        nextBody: 'Open na de inrichting het beheergedeelte om de eerste gebruikers uit te nodigen en hun rollen toe te wijzen.',
        demoWarning: 'Bij het afronden worden het demobedrijf en alle gebruikers die je tijdens het verkennen hebt uitgenodigd, gewist.',
      },
      sections: {
        ats: {
          title: 'Werving',
          subtitle: 'Stel in hoe sollicitaties en wervings-e-mails werken.',
          fields: {
            fromName: { label: 'Afzendernaam', hint: 'Wordt getoond in e-mails aan kandidaten.' },
            signature: { label: 'E-mailhandtekening', hint: 'Wordt toegevoegd aan uitgaande kandidaat-e-mails.' },
          },
          jobPosting: {
            title: 'Vacature',
            hint: 'Het sollicitatiecontact en logo die op externe vacatures worden getoond (optioneel — je kunt dit ook later instellen).',
            contactName: 'Naam contactpersoon',
            contactEmail: 'Contact-e-mail',
            logo: 'Vacaturelogo',
            uploadLogo: 'Logo uploaden',
            removeLogo: 'Verwijderen',
            rePick: 'Je logo is nog niet geüpload — selecteer het opnieuw.',
            contactEmailInvalid: 'Voer een geldig e-mailadres in.',
          },
          workflow: {
            title: 'Wervingsproces',
            participantsQuestion: 'Wie is betrokken bij vacatures en sollicitaties?',
            worksCouncil: 'Ondernemingsraad',
            sbv: 'Vertegenwoordiging van medewerkers met een beperking',
            legalSignOff: 'Juridische zaken – keurt een vacature goed voordat die wordt gepubliceerd',
            assessmentCentreQuestion: 'Gebruik je assessmentcenters?',
            assessmentCentre: 'Ja, we gebruiken assessmentcenters',
            hint: 'Je kunt het proces later altijd nog bewerken en bijwerken in de ATS.',
          },
        },
        time_tracking: {
          title: 'Tijd',
          subtitle: 'Boekingssoorten en arbeidstijdregels.',
          fields: {
            bookingTypes: { label: 'Boekingssoorten', hint: 'Voeg de boekingssoorten toe die je gebruikt.', placeholder: 'bijv. Werk' },
          },
          companyHolidays: {
            title: 'Bedrijfssluiting',
            hint: 'Dagen waarop het bedrijf gesloten is – bijvoorbeeld een halve dag op kerstavond en oudejaarsdag. Op die dagen gelden geen normuren. Per regel bepaal je of die van het verlof afgaat; dat kun je later aanpassen in de instellingen van Tijd.',
            empty: 'Nog geen bedrijfssluiting ingevoerd.',
            suggestions: 'Suggesties:',
            christmasEve: 'Kerstavond',
            newYearsEve: 'Oudejaarsdag',
            name: 'Naam',
            namePlaceholder: 'bijv. Tussen kerst en oud en nieuw',
            from: 'Van',
            to: 'Tot en met (optioneel)',
            halfDay: 'Halve dag',
            yearly: 'Elk jaar',
            deductsFromLeave: 'Van het verlof aftrekken',
            rangeReversed: 'De einddatum ligt vóór de begindatum.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Opleidingsberoepen.',
          fields: {
            professions: { label: 'Opleidingsberoepen', hint: 'De leerberoepen waarin je opleidt.', placeholder: 'bijv. IT-specialist' },
          },
        },
        people: {
          title: 'Personeel',
          subtitle: 'Gedeelde begrippen voor de hele suite.',
          fields: {
            salutations: { label: 'Aanheffen', hint: 'Voeg aanheffen toe naast de standaardset.', placeholder: 'bijv. Mx' },
            contractTypes: { label: 'Contractsoorten', hint: 'Voeg contractsoorten toe naast de standaardset.', placeholder: 'bijv. Werkstudent' },
            workTimeModels: { label: 'Arbeidstijdmodellen', hint: 'Voeg modellen toe naast de standaardset.', placeholder: 'bijv. Duobaan' },
            workLocationTypes: { label: 'Werklocaties', hint: 'Voeg werklocatietypen toe naast de standaardset.', placeholder: 'bijv. Buitendienst' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Demo wissen…',
        body: 'Het demobedrijf wordt verwijderd zodat je echte inrichting schoon begint.',
      },
      applying: {
        title: 'Je suite wordt ingericht…',
        body: 'Je antwoorden worden toegepast. Dit duurt maar even.',
      },
      steps: {
        company: 'Bedrijfsprofiel',
      },
      error: 'Er is iets misgegaan bij het toepassen van je inrichting.',
      retry: 'Opnieuw proberen',
      backToSetup: 'Terug naar instellen',
      skipStep: 'Afronden zonder deze stap',
      skipped: 'Overgeslagen: {steps}. Je kunt dit altijd later in de instellingen regelen.',
      resume: 'Inrichting hervatten',
      stalled: 'Dit duurt langer dan verwacht.',
      wipeFailed: 'De demo kon niet worden gewist. Probeer opnieuw om verder te gaan.',
      logoMissing: 'Je logo is niet geüpload (verloren bij het herladen) — je kunt het later toevoegen in de instellingen voor vacatures.',
      workflowFailed: 'Je wervingsketen kon niet worden gegenereerd, dus je workspace begint met de standaardketen. Al het andere is toegepast — open de workflow-instellingen in Recruiting om de generator opnieuw te starten.',
      workflowDrafted: "Je wervingsproces is opgeslagen als concept omdat {roles} nog niemand toegewezen heeft. Open de workflow-instellingen in Recruiting om het te activeren zodra de rol bezet is.",
      workflowRoles: {
        ats_works_council: "de ondernemingsraad",
        ats_sbv: "de vertegenwoordiging van medewerkers met een arbeidsbeperking",
        ats_legal: "juridische zaken",
      },
      continue: 'Doorgaan naar werkruimte',
    },
  },
  tenants: {
    switcherLabel: 'Van workspace wisselen',
    supportAccessBadge: 'Support',
    supportAccessUntil: 'Tijdelijke supporttoegang tot {until}',
    supportAccessBanner: 'lumi-support heeft momenteel tijdelijke toegang tot deze workspace.',
    supportAccessReview: 'Beoordelen',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Wat een verwijdering blokkeert',
      intro: 'Personeelsdocumenten zonder bewaartermijn worden onbeperkt bewaard: niemand heeft bepaald hoe lang ze bewaard moeten blijven, en een document zonder beslissing wordt nooit automatisch verwijderd. Hier zie je ze, zodat de termijnen ingesteld kunnen worden.',
      sensitivePlaceholder: 'Gevoelig document',
      categories: {
        contract: 'Arbeidsovereenkomst',
        contract_amendment: 'Contractwijziging',
        certificate: 'Getuigschrift',
        attestation: 'Verklaring',
        warning: 'Waarschuwing',
        other: 'Overig document',
      },
      outcomes: {
        refused: 'Verwijdering geweigerd',
        partial: 'Gedeeltelijk verwijderd',
      },
      list: {
        title: 'Documenten zonder bewaartermijn',
        fixHint: 'De oudste staan bovenaan. Stel een bewaartermijn in op het document in het personeelsdossier, dan verdwijnt het uit deze lijst.',
        loading: 'Documenten laden…',
        loadError: 'De lijst kon niet worden geladen. Probeer het opnieuw — lees dit niet als “niets gevonden”.',
        empty: 'Elk document in deze werkruimte heeft een bewaartermijn.',
        uploadedLabel: 'Geüpload',
        truncated: 'Alleen de {count} oudste documenten worden getoond. Er wachten er meer op een bewaartermijn.',
      },
    },
    myData: {
      title: 'Mijn gegevens',
      intro: 'Hier vraag je op welke gegevens deze workspace over je bewaart, vraag je om een correctie of vraag je om verwijdering. Elk verzoek wordt vastgelegd en beantwoord door de mensen die hier verantwoordelijk zijn voor gegevensbescherming, en je volgt het hier.',
      requests: {
        title: 'Mijn verzoeken',
        loading: 'Je verzoeken worden geladen…',
        loadError: 'Je verzoeken konden niet worden geladen. Je kunt hieronder toch een verzoek indienen.',
        empty: 'Je hebt nog geen verzoek ingediend.',
        filedLabel: 'Ingediend',
        dueLabel: 'Antwoord verwacht',
        outcomeLabel: 'Resultaat',
        awaitingRelease: 'Kopie wordt gecontroleerd',
      },
      kinds: {
        access: 'Kopie van mijn gegevens',
        rectification: 'Correctie',
        erasure: 'Verwijdering',
      },
      statuses: {
        received: 'Ontvangen',
        verifying: 'Identiteit wordt gecontroleerd',
        in_progress: 'In behandeling',
        awaiting_subject: 'Wacht op jouw antwoord',
        completed: 'Afgerond',
        refused: 'Afgewezen',
        withdrawn: 'Ingetrokken',
      },
      outcomes: {
        erased: 'Gegevens verwijderd',
        suppressed: 'Gegevens verwijderd, minimale registratie blijft',
        refused: 'Afgewezen',
        partial: 'Gedeeltelijk afgehandeld',
        answered: 'Beantwoord',
      },
      actions: {
        access: {
          title: 'Een kopie van mijn gegevens vragen',
          body: 'Je kunt een kopie vragen van de gegevens die deze workspace over je bewaart. Het is geen directe download: de kopie wordt eerst samengesteld en je hoort het zodra die klaarstaat.',
          where: 'Een kopie die klaarstaat wordt nooit als bijlage gemaild. Je krijgt een e-mail, meldt je aan bij je lumi HR-account en downloadt de kopie daar.',
          cta: 'Kopie vragen',
          detailLabel: 'Aanvulling (optioneel)',
          detailHint: 'Bijvoorbeeld als je maar een deel van je gegevens wilt.',
        },
        rectification: {
          title: 'Een correctie vragen',
          body: 'Klopt iets niet wat deze workspace over je bewaart, dan kun je om een correctie vragen.',
          cta: 'Correctie vragen',
          detailLabel: 'Wat klopt er niet, en wat moet er staan?',
          detailHint: 'Beschrijf de gegevens zo precies mogelijk, zodat ze gevonden en gecontroleerd kunnen worden.',
          selfTitle: 'Een deel wijzig je zelf',
          selfFields: 'Je naam en aanhef, je geslacht, je contact-e-mailadres, je telefoonnummer, je adres, je nationaliteit, je burgerlijke staat en je taal wijzig je zelf in je profiel.',
          selfLink: 'Mijn profiel openen',
          askBody: 'Voor al het andere – geboortedatum, personeelsnummer, contract-, loon- of belastinggegevens, je documenten – gebruik je het verzoek hieronder.',
        },
        erasure: {
          title: 'Verwijdering van mijn gegevens vragen',
          body: 'Je kunt deze workspace vragen de gegevens te verwijderen die hij over je bewaart.',
          cta: 'Verwijdering vragen',
          confirm: 'Je verzoek wordt beoordeeld door de verantwoordelijken in deze workspace. Gegevens die wettelijk bewaard moeten blijven of nog nodig zijn voor je dienstverband, kunnen niet worden verwijderd. Je hoort wat is verwijderd en wat blijft.',
          detailLabel: 'Aanvulling (optioneel)',
          detailHint: 'Bijvoorbeeld welke gegevens je bedoelt als het niet om alles gaat.',
        },
      },
      form: {
        submit: 'Verzoek versturen',
        submitting: 'Versturen…',
        cancel: 'Annuleren',
        success: 'Je verzoek is vastgelegd. Je vindt het hierboven onder ‘Mijn verzoeken’.',
        errorGeneric: 'Je verzoek kon niet worden verstuurd. Er is niets vastgelegd – probeer het opnieuw.',
        errorRateLimit: 'Je hebt in korte tijd meerdere verzoeken verstuurd. Probeer het later opnieuw.',
      },
    },
    export: {
      title: 'Deze werkruimte exporteren',
      intro: 'Je kunt op elk moment een volledige kopie downloaden van alles wat deze werkruimte bewaart, in machineleesbare vorm en zonder het ons te vragen.',
      contents: {
        title: 'Wat er in dit bestand zit',
        body: 'Het archief bevat de gegevens van alle personen in leesbare vorm en daarnaast de actieve toegangssleutels van deze werkruimte: de AI-sleutel, agendalinks met hun tokens en de inloggegevens van gekoppelde aanbieders. Het archief bevat ook, voor Personeel, Werving en Tijd, een HR Open Standards-document (HR-JSON) — het gedeelde formaat om je gegevens naar een andere aanbieder mee te nemen.',
        handling: 'Bewaar het net zo zorgvuldig als die sleutels zelf. Wie het bestand én het wachtwoord heeft, heeft alles wat erin staat.',
      },
      roleRequired: {
        title: 'Voor deze export is de rol ‘Gegevensbescherming’ nodig',
        body: 'Het archief bevat elk bestand dat in deze werkruimte staat — loonstroken, medische verklaringen en identiteitsbewijzen daarbij — naast de persoonsgegevens van iedereen en de actieve toegangssleutels van deze werkruimte.',
        hint: 'Eigenaar zijn van de werkruimte is daarvoor niet meer genoeg: wie de export start, moet ook de rol ‘Gegevensbescherming’ hebben. Die rol wordt samen met de overige suite-rollen toegekend in het gebruikersbeheer, en kan ook aan jou worden toegekend.',
      },
      start: {
        title: 'Export starten',
        body: 'Kies een wachtwoord. Het archief wordt daarmee versleuteld en alleen daarmee gaat het open.',
        passphraseWarning: 'We bewaren je wachtwoord nooit en kunnen het niet herstellen. Als je het kwijtraakt, kan het archief niet meer worden geopend — er is geen reset.',
        passphraseLabel: 'Wachtwoord',
        passphraseHint: 'Minstens {min} tekens. Kies iets langs dat je veilig kunt bewaren.',
        confirmLabel: 'Wachtwoord herhalen',
        submit: 'Export starten',
        submitting: 'Bezig met starten…',
        success: 'De export is gestart. Hij wordt op de achtergrond gemaakt en verschijnt hieronder zodra hij klaar is.',
        errorTooShort: 'Het wachtwoord heeft minstens {min} tekens nodig.',
        errorMismatch: 'De twee wachtwoorden komen niet overeen.',
        errorAlreadyRunning: 'Er loopt al een export van deze werkruimte. Wacht tot die klaar is voordat je een nieuwe start.',
        errorTooMany: 'Deze werkruimte heeft voorlopig het maximale aantal exports gestart. Probeer het later opnieuw.',
        errorGeneric: 'We konden niet bevestigen dat de export is gestart. Bekijk de lijst hieronder voordat je een nieuwe start.',
      },
      list: {
        title: 'Exports van deze werkruimte',
        loading: 'Exports laden…',
        loadError: 'De exports konden niet worden geladen.',
        empty: 'Deze werkruimte is nog niet geëxporteerd.',
        linkHint: 'Een downloadlink is maar even geldig. Werkt hij niet meer, gebruik dan opnieuw de knop.',
        retentionHint: 'Elk archief wordt automatisch verwijderd zodra het verloopt — de datum staat ernaast.',
        startedLabel: 'Gestart',
        expiresLabel: 'Beschikbaar tot',
        download: 'Downloaden',
        preparing: 'Voorbereiden…',
        downloadError: 'De download kon niet worden voorbereid. Mogelijk is het archief er niet meer.',
        gone: 'Het archief is verwijderd. Start een nieuwe export als je nog een kopie nodig hebt.',
        failedHint: 'Deze export is niet afgerond. Je kunt een nieuwe starten.',
        runningHint: 'Deze export wordt nog gemaakt.',
      },
      statuses: {
        requested: 'Aangevraagd',
        exporting: 'Wordt gemaakt',
        exported: 'Klaar',
        failed: 'Mislukt',
        expired: 'Verwijderd',
      },
    },
    settingsPanel: {
      title: 'Gegevensverwerking',
      body: 'Je kunt je gegevens laten verwijderen of corrigeren, of een kopie opvragen, {link}.',
      linkLabel: 'hier',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Deze lijst is voor de rol gegevensbescherming',
      description: 'Verzoeken van betrokkenen worden behandeld door de eigenaar van de workspace of door wie de rol „Gegevensbescherming” heeft.',
    },
    intro: {
      title: 'Verzoeken van betrokkenen',
      body: 'Verzoeken van personen over de gegevens die deze workspace over hen bewaart. Elk verzoek moet binnen een maand na ontvangst worden beantwoord (art. 12 lid 3 AVG). Bij een complex verzoek kan de termijn twee keer met een maand worden verlengd — met een reden die de persoon moet horen.',
    },
    filters: {
      label: 'Verzoeken tonen',
      open: 'Openstaand',
      overdue: 'Te laat',
      dueSoon: 'Binnen 7 dagen',
      closed: 'Recent beantwoord',
    },
    empty: {
      title: 'Geen verzoeken van betrokkenen',
      description: 'Als iemand naar zijn gegevens vraagt — in lumi, per e-mail, post of telefoon — verschijnt het verzoek hier met zijn termijn.',
    },
    emptyFilter: 'Geen verzoeken in deze weergave.',
    truncated: 'Niet alle verzoeken passen op deze pagina. De vroegste termijnen staan bovenaan.',
    badges: {
      overdue: 'Te laat',
      dueSoon: 'Bijna verlopen',
      legalHold: 'Bewaarplicht',
      reviewReady: 'Klaar voor controle',
      reviewReleased: 'Vrijgegeven',
      reviewDelivered: 'Bezorgd',
    },
    row: {
      received: 'Ontvangen',
      due: 'Antwoord uiterlijk',
      closed: 'Afgesloten',
      subject: 'Betreft',
      channel: 'Binnengekomen via',
      outcome: 'Resultaat',
      extensions: 'Termijn {count} van 2 keer verlengd',
      postponed: 'Herinneringen gepauzeerd tot {date}',
      vetoWindow: 'De wissing kan nog tot {date} worden gestopt',
      reviewFlagged: 'Jouw beslissing is nodig: {flagged} van {total} items',
      reviewNoneFlagged: 'Geen items gemarkeerd',
      reviewEmpty: 'De kopie bevat geen items',
      reviewOpen: 'Controleren',
      reviewReleased: 'Vrijgegeven, wordt bezorgd',
      reviewDelivered: 'Bezorgd, wordt afgesloten',
    },
    legalHold: {
      tenant: 'Er geldt een bewaarplicht voor de hele workspace ({reason}).',
      subject: 'Op deze persoon rust een bewaarplicht ({reason}).',
      consequence: 'De gegevens mogen niet worden gewist. Het rechtmatige antwoord is een weigering die precies die grondslag noemt — de bewaarplicht schort de termijn niet op.',
    },
    automated: {
      pending: 'lumi beantwoordt dit verzoek zelf: zodra je de identiteit van de persoon hebt gecontroleerd en het verzoek op „In behandeling” zet, stelt lumi de kopie van de gegevens samen. Die wacht dan op jouw controle. Nadat je haar hebt vrijgegeven, hoort de persoon waar die te downloaden is en sluit het verzoek vanzelf.',
      running: 'lumi stelt nu de kopie van de gegevens van deze persoon samen. Die wacht daarna op jouw controle — de persoon hoort pas waar die te downloaden is nadat je haar hebt vrijgegeven.',
    },
    detail: {
      show: 'Tonen wie het vroeg',
      hide: 'Details verbergen',
      loading: 'Details laden…',
      loadError: 'De details van dit verzoek konden niet worden geladen.',
      subjectLabel: 'Opgegeven naam',
      subjectEmail: 'E-mailadres',
      subjectPhone: 'Telefoonnummer',
      requestDetail: 'Wat er gevraagd werd',
      onBehalfReason: 'Namens de persoon vastgelegd omdat',
      extensionReason: 'Reden van de verlenging',
      outcomeBasis: 'Genoemde grondslag',
      nothingOnFile: 'Contactgegevens',
      nothingOnFileValue: 'Bij dit verzoek zijn geen naam, adres of bericht vastgelegd.',
    },
    kinds: {
      access: 'Kopie van de eigen gegevens',
      rectification: 'Rectificatie',
      erasure: 'Wissing',
      restriction: 'Beperking van de verwerking',
      portability: 'Gegevensoverdraagbaarheid',
      objection: 'Bezwaar tegen de verwerking',
    },
    statuses: {
      received: 'Ontvangen',
      verifying: 'Identiteit wordt gecontroleerd',
      in_progress: 'In behandeling',
      awaiting_subject: 'Wacht op de persoon',
      completed: 'Afgerond',
      refused: 'Geweigerd',
      withdrawn: 'Ingetrokken',
    },
    outcomes: {
      erased: 'Gegevens gewist',
      suppressed: 'Gegevens gewist, minimale registratie bewaard',
      refused: 'Geweigerd',
      partial: 'Deels uitgevoerd',
      answered: 'Volledig beantwoord',
    },
    subjectTypes: {
      person: 'Een personeelsdossier',
      tenant_user: 'Een lid zonder personeelsdossier',
      candidate: 'Een sollicitant',
      unlinked: 'Niet aan een dossier gekoppeld',
    },
    channels: {
      'self-service': 'Door de persoon in lumi ingediend',
      'candidate-portal': 'Sollicitantenportaal',
      email: 'E-mail',
      post: 'Per post',
      phone: 'Telefoon',
      unknown: 'Niet vastgelegd',
    },
    actions: {
      advance: {
        verifying: 'Identiteit controleren',
        in_progress: 'In behandeling nemen',
        awaiting_subject: 'Wachten op de persoon',
      },
      extend: 'Termijn verlengen',
      close: 'Verzoek afsluiten',
      postpone: 'Herinneringen pauzeren',
      veto: 'Vetotermijn openen',
      hold: 'Bewaarplicht voor persoon',
      restrict: 'Verwerking beperken',
      record: 'Verzoek vastleggen',
    },
    confirmAutomated: {
      title: 'De kopie van de gegevens samenstellen?',
      body: 'Met „In behandeling” geef je lumi opdracht alles samen te stellen wat deze workspace over de persoon bewaart. De kopie gaat nog niet naar de persoon: ze wacht op jouw controle, en de persoon hoort pas waar ze te downloaden is nadat je haar hebt vrijgegeven. Doe dit pas als de identiteit vaststaat.',
      confirm: 'Starten',
    },
    toast: {
      advanced: 'Verzoek op „{status}” gezet.',
      extended: 'Termijn verlengd tot {date}.',
      closed: 'Verzoek afgesloten.',
      postponed: 'Herinneringen gepauzeerd tot {date}.',
      vetoOpened: 'Vetotermijn geopend. Het wissen wacht 72 uur.',
      holdPlaced: 'Bewaarplicht ingesteld.',
      holdReleased: 'Bewaarplicht opgeheven.',
      holdAttested: 'Bewaarplicht voor nog zes maanden bevestigd.',
      restrictionPlaced: 'Verwerking beperkt.',
      restrictionNotified: 'Melding vastgelegd.',
      restrictionLifted: 'Beperking opgeheven.',
      recorded: 'Verzoek vastgelegd.',
    },
    extend: {
      title: 'Termijn verlengen',
      body: 'Art. 12 lid 3 AVG staat twee verlengingen van een maand toe als een verzoek complex is of er veel zijn. Laat het de persoon binnen de eerste maand weten, met de reden.',
      remaining: 'Resterende verlengingen: {count}',
      reasonLabel: 'Reden van de vertraging',
      reasonHint: 'Wordt bij het verzoek vastgelegd. Geef de persoon dezelfde reden.',
      submit: 'Met een maand verlengen',
      errorReason: 'Geef de reden van de vertraging op.',
    },
    close: {
      title: 'Verzoek afsluiten',
      body: 'Een afgesloten verzoek kan niet worden heropend: het is het bewijs van hoe en wanneer de workspace heeft geantwoord.',
      statusLabel: 'Hoe is het afgesloten?',
      outcomeLabel: 'Wat is er gedaan',
      outcomePlaceholder: 'Kiezen…',
      basisLabel: 'Wettelijke grondslag',
      basisHint: 'De grondslag voor wat bewaard of geweigerd is, bijvoorbeeld een bewaarplicht of art. 12 lid 5 AVG.',
      submit: 'Verzoek afsluiten',
      errorOutcome: 'Kies wat er gedaan is.',
      errorBasis: 'Een weigering of gedeeltelijk antwoord moet de wettelijke grondslag noemen.',
      conflict: 'Het verzoek kon zo niet worden afgesloten. Een bewaarplicht of een open vetotermijn kan het wissen van de gegevens blokkeren, of het verzoek is intussen gewijzigd — laad de lijst opnieuw en controleer.',
    },
    record: {
      title: 'Verzoek vastleggen',
      body: 'Voor een verzoek dat per e-mail, post of telefoon binnenkwam. De termijn van een maand loopt vanaf de dag van binnenkomst, niet vanaf vandaag. Een vastgelegd verzoek begint als ontvangen.',
      choose: 'Kiezen…',
      kindLabel: 'Soort verzoek',
      channelLabel: 'Binnengekomen via',
      receivedLabel: 'Ontvangen op',
      receivedHint: 'De dag waarop het verzoek de werkruimte bereikte — uiterlijk vandaag.',
      subjectLabel: 'Betrokkene',
      modes: {
        person: 'Een persoon in Personeel',
        candidate: 'Een sollicitatie in Werving',
        unlinked: 'Geen dossier',
      },
      personLabel: 'Persoon zoeken',
      personHint: 'Zoek op naam of e-mailadres.',
      candidateLabel: 'Sollicitant',
      candidateHint: 'Zoek op naam of e-mailadres. Alleen sollicitanten die je rol in Werving mag openen worden gevonden.',
      candidateRefused: 'Je rollen in Werving staan zoeken naar sollicitaties niet toe. Kies „Geen dossier” en vul de naam in die de persoon opgaf.',
      searchPlaceholder: 'Naam of e-mailadres',
      picker: {
        searching: 'Zoeken…',
        typeMore: 'Minstens {count} tekens',
        noMatch: 'Niets gevonden. Staat de persoon nergens geregistreerd, kies dan „Geen dossier”.',
        error: 'Het zoeken is mislukt. Staat de persoon nergens geregistreerd, kies dan „Geen dossier”.',
        refused: 'Je rollen staan zoeken naar sollicitaties niet toe.',
        rateLimited: 'Te veel zoekopdrachten – zo verder',
        resultsAnnouncement: 'Eén treffer | {count} treffers',
        clear: 'Selectie wissen',
      },
      nameLabel: 'Opgegeven naam',
      nameHint: 'Zoals de persoon ondertekende of zich voorstelde.',
      emailLabel: 'E-mailadres (optioneel)',
      detailLabel: 'Wat wordt er gevraagd?',
      detailHint: 'Optioneel. Zo veel mogelijk in de woorden van de persoon.',
      reasonLabel: 'Waarom leg je dit namens de persoon vast?',
      reasonHint: 'Bijvoorbeeld: brief aan HR van 3 mei, of telefoontje aan de receptie. Wordt met je naam vastgelegd.',
      submit: 'Verzoek vastleggen',
      errorKind: 'Kies het soort verzoek.',
      errorChannel: 'Kies hoe het verzoek binnenkwam.',
      errorReceived: 'Kies de dag waarop het verzoek binnenkwam.',
      errorFuture: 'Een verzoek kan niet in de toekomst binnenkomen. Kies vandaag of een eerdere dag.',
      errorPerson: 'Kies de persoon uit de zoekresultaten, of „Geen dossier”.',
      errorCandidate: 'Kies de sollicitatie uit de zoekresultaten, of „Geen dossier”.',
      errorName: 'Vul de naam in die de persoon opgaf.',
      errorEmail: 'Vul een geldig e-mailadres in, of laat het veld leeg.',
      errorReason: 'Geef aan waarom je het verzoek namens de persoon vastlegt.',
    },
    errors: {
      conflict: 'Deze stap is niet meer mogelijk — het verzoek is intussen gewijzigd. Laad de lijst opnieuw.',
      notLinked: 'Dit verzoek is aan geen enkel dossier gekoppeld, dus er is niemand om te bewaren of te beperken.',
    },
    progress: {
      title: 'Wissing per module',
      show: 'Voortgang van de wissing tonen',
      hide: 'Voortgang van de wissing verbergen',
      loading: 'Wisregister wordt geladen…',
      loadError: 'Het wisregister kon niet worden geladen.',
      unlinked: 'Dit verzoek is aan geen dossier gekoppeld, dus geen module heeft er iets voor gewist.',
      lastExecuted: 'vastgelegd op {date}',
      states: {
        done: 'Gewist',
        heldNothing: 'Niets bewaard',
        pending: 'Nog niet vastgelegd',
        deferred: 'Uitgesteld — module gedeactiveerd',
      },
      modules: {
        people: 'Personeel',
        ats: 'Sollicitaties',
        time: 'Tijd',
        apprentice: 'Opleiding',
        payroll: 'Salarisadministratie',
        privacy: 'Privacyregister',
      },
    },
    postpone: {
      title: 'Herinneringen pauzeren',
      body: 'Stopt de herinneringsmails tot de gekozen dag. De wettelijke termijn verschuift niet — verleng daarvoor het verzoek.',
      untilLabel: 'Pauzeren tot',
      untilHint: 'Uiterlijk tot de antwoordtermijn, {date}.',
      reasonLabel: 'Reden',
      reasonHint: 'Wordt bij het verzoek vastgelegd, zodat de pauze later te verantwoorden is.',
      submit: 'Herinneringen pauzeren',
      errorUntil: 'Kies de dag waarop de herinneringen weer beginnen.',
      errorRange: 'Kies een dag tussen morgen en de antwoordtermijn.',
      errorReason: 'Geef de reden van de pauze op.',
    },
    veto: {
      title: 'Vetotermijn openen?',
      body: 'De komende 72 uur wordt het wissen tegengehouden: het verzoek kan niet als gewist worden afgesloten. Gebruik de tijd om na te gaan of een bewaarplicht of een weigering nodig is. De termijn kan niet eerder worden gesloten.',
      confirm: 'Vetotermijn openen',
    },
    holds: {
      title: 'Bewaarplichten',
      intro: 'Een bewaarplicht voorkomt dat gegevens worden gewist — door een verzoek, de bewaarregels of het verwijderen van de workspace — totdat hij wordt opgeheven. Elke bewaarplicht moet om de zes maanden opnieuw worden bevestigd.',
      placeTenant: 'Bewaarplicht voor de hele workspace',
      empty: 'Er is geen bewaarplicht actief.',
      lapsedNotice: 'Bewaarplichten met verstreken bevestigingsdatum: {count}. Ze blokkeren het wissen nog steeds — bevestig of hef ze op.',
      scopeTenant: 'Hele workspace',
      scopeSubject: 'Eén persoon',
      lapsed: 'Bevestiging te laat',
      placedAt: 'Ingesteld op',
      attestationDue: 'Bevestigen vóór',
      basis: 'Rechtsgrond',
      attest: 'Nog nodig',
      attestConfirm: {
        title: 'Bewaarplicht behouden?',
        body: 'Je bevestigt dat de reden voor de bewaarplicht nog geldt. Hij blijft nog zes maanden van kracht.',
        confirm: 'Behouden',
      },
      release: {
        open: 'Opheffen',
        title: 'Bewaarplicht opheffen',
        warning: 'Vanaf nu mogen de gegevens die deze bewaarplicht beschermde worden gewist — door openstaande verzoeken, de bewaarregels of het verwijderen van de workspace. Dit kan niet ongedaan worden gemaakt.',
        reasonLabel: 'Waarom is de bewaarplicht niet meer nodig?',
        reasonHint: 'Wordt met je naam vastgelegd.',
        submit: 'Bewaarplicht opheffen',
        errorReason: 'Geef de reden van de opheffing op.',
      },
      place: {
        titleTenant: 'Bewaarplicht voor de hele workspace',
        titleSubject: 'Bewaarplicht voor deze persoon',
        bodyTenant: 'Zolang de bewaarplicht geldt, mogen geen gegevens van deze workspace worden gewist — niet door verzoeken, niet door de bewaarregels en niet door het verwijderen van de workspace.',
        bodySubject: 'Zolang de bewaarplicht geldt, mogen geen gegevens worden gewist van de persoon die dit verzoek noemt. Het verzoek moet toch binnen de termijn worden beantwoord.',
        reasonLabel: 'Reden',
        reasonHint: 'Bijvoorbeeld de rechtszaak of het verzoek van een instantie dat bewaren vereist.',
        basisLabel: 'Rechtsgrond (optioneel)',
        basisHint: 'Een korte verwijzing, bijvoorbeeld het wetsartikel of het zaaknummer.',
        submit: 'Bewaarplicht instellen',
        errorReason: 'Geef de reden van de bewaarplicht op.',
      },
      errors: {
        notActive: 'Deze bewaarplicht is niet meer actief — hij is intussen gewijzigd. De lijst is opnieuw geladen.',
      },
    },
    restrictions: {
      title: 'Beperkingen van de verwerking',
      intro: 'Een beperkt dossier mag worden bewaard, maar niet gebruikt (art. 18 AVG). Voordat een beperking wordt opgeheven, moet de persoon worden ingelicht.',
      empty: 'Er is geen verwerking beperkt.',
      originSystem: 'Ingesteld na een wissing',
      originRequest: 'Uit een verzoek',
      notified: 'Persoon ingelicht op {date}',
      notNotified: 'Persoon nog niet ingelicht',
      placedAt: 'Beperkt sinds {date}',
      notifyOpen: 'Persoon inlichten',
      notifyAgain: 'Nieuwe melding vastleggen',
      lift: 'Beperking opheffen',
      liftConfirm: {
        title: 'Beperking opheffen?',
        body: 'Het dossier kan weer worden gebruikt zoals voorheen. De persoon is ingelicht.',
        bodySystem: 'Deze beperking is automatisch ingesteld op wat na het wissen van de gegevens van de persoon is bewaard. Opheffen maakt deze gegevens weer bewerkbaar en bruikbaar. Hef haar alleen op als de beperking niet meer nodig is.',
        confirm: 'Beperking opheffen',
      },
      errors: {
        notActive: 'Deze beperking is niet meer actief, of de persoon is nog niet ingelicht. De lijst is opnieuw geladen.',
      },
      place: {
        title: 'Verwerking beperken',
        body: 'Het dossier van de persoon die dit verzoek noemt, blijft bewaard, maar mag niet meer worden gebruikt tot de beperking wordt opgeheven. De beperking wordt aan dit verzoek gekoppeld.',
        reasonLabel: 'Reden',
        reasonHint: 'Bijvoorbeeld: de persoon betwist de juistheid van de gegevens.',
        submit: 'Beperken',
        errorReason: 'Geef de reden van de beperking op.',
      },
      notify: {
        title: 'Persoon inlichten',
        body: 'De persoon moet worden ingelicht voordat de beperking wordt opgeheven (art. 18, lid 3, AVG).',
        modeLabel: 'Hoe wordt de persoon ingelicht?',
        modeSend: 'lumi stuurt een e-mail',
        modeManual: 'Al op een andere manier ingelicht',
        manualOnly: 'Deze beperking is aan geen verzoek gekoppeld, dus lumi heeft geen adres. Licht de persoon zelf in en leg het hier vast.',
        employerLabel: 'Werkgever die in de e-mail wordt genoemd',
        employerHint: 'De persoon moet kunnen zien wie haar gegevens heeft beperkt.',
        refLabel: 'Kenmerk',
        refHint: 'Hoe je haar hebt ingelicht, bijvoorbeeld „brief van 3 mei” of een dossiernummer.',
        dateLabel: 'Ingelicht op',
        dateHint: 'Leeg laten voor vandaag.',
        submitSend: 'E-mail sturen',
        submitManual: 'Melding vastleggen',
        sendRefused: 'De e-mail kon niet worden verstuurd: het verzoek bevat geen e-mailadres. Licht de persoon op een andere manier in en leg het vast.',
        errorEmployer: 'Noem de werkgever.',
        errorRef: 'Geef een kenmerk voor de melding op.',
      },
    },
    review: {
      title: 'Kopie controleren',
      intro: 'Zo leest de persoon haar kopie. Gemarkeerde items beslis je een voor een: vrijgeven of achterhouden (art. 15, lid 4, AVG). Al het andere is alleen-lezen.',
      back: 'Terug naar de verzoeken',
      counter: {
        undecided: 'Nog {undecided} van {flagged} items te beslissen',
        allDecided: 'Alle {flagged} gemarkeerde items zijn beslist',
        noneFlagged: 'Er is geen item gemarkeerd — je kunt de kopie meteen vrijgeven',
      },
      modules: {
        people: 'Personeel',
        ats: 'Sollicitaties',
        time: 'Tijd',
        apprentice: 'Opleiding',
      },
      moduleState: {
        notInstalled: 'Deze module hoort niet bij deze workspace, dus daar is niets opgeslagen.',
        removed: 'Deze module is uit de workspace verwijderd; er is niets over de persoon in overgebleven.',
        unavailable: 'Deze module was niet bereikbaar toen de kopie werd samengesteld — dit onderdeel ontbreekt in de kopie. Zet het verzoek op „Wachten op de persoon” en daarna weer op „In behandeling nemen”, dan stelt lumi de kopie opnieuw samen — of geef haar bewust vrij zonder dit onderdeel.',
      },
      moduleEmpty: 'Hier is niets over de persoon opgeslagen.',
      delivered: 'Bezorgd — lumi sluit het verzoek zo af',
      self: {
        title: 'Dit verzoek gaat over jou',
        description: 'Een andere verantwoordelijke voor gegevensbescherming moet de kopie controleren. Je kunt het verzoek in plaats daarvan met de hand beantwoorden.',
      },
      unverified: 'lumi kon net niet controleren of dit verzoek over jou gaat. Probeer het zo nog eens.',
      sectionMeta: 'Verwerking: {activity}',
      flagged: 'Gemarkeerd',
      flagReason: {
        written: 'Door iemand anders over de persoon geschreven, of noemt andere personen. Weeg af of de persoon dit item mag lezen.',
        generic: 'Kan gegevens over andere personen bevatten of van anderen afkomstig zijn. Weeg af volgens art. 15, lid 4, AVG.',
      },
      state: {
        undecided: 'Nog niet beslist',
        release: 'Wordt vrijgegeven',
        withhold: 'Wordt achtergehouden',
      },
      decision: {
        group: 'Beslissing over een item in „{section}”',
        release: 'Vrijgeven',
        withhold: 'Achterhouden',
        changeReason: 'Reden wijzigen',
        reasonLabel: 'Reden voor de persoon',
        reasonHint: 'De persoon leest deze reden in haar kopie. Schrijf hem voor haar en geef de inhoud van het item niet weer.',
        reasonSave: 'Opslaan als achtergehouden',
        reasonRequired: 'Geef een reden op.',
        saveError: 'De beslissing kon niet worden opgeslagen. Het item behoudt zijn vorige stand.',
      },
      release: {
        action: 'Kopie vrijgeven',
        blocked: 'Beslis eerst over de {undecided} openstaande gemarkeerde items, dan kun je de kopie vrijgeven.',
        confirmTitle: 'Kopie vrijgeven?',
        confirmBody: 'lumi maakt nu de kopie zonder de achtergehouden items ({withheld}), laat het de persoon weten en sluit het verzoek.',
        confirmBodyNone: 'lumi maakt nu de kopie, laat het de persoon weten en sluit het verzoek.',
        confirmLabel: 'Vrijgeven',
        done: 'Vrijgegeven — lumi bezorgt de kopie',
      },
      errors: {
        undecided: 'Er staan nog gemarkeerde items open. De pagina is opnieuw geladen.',
        expired: 'De kopie is verlopen — lumi maakt een nieuwe en je ziet die hier binnenkort terug',
        closed: 'Het verzoek is niet meer open. De kopie kan niet meer worden vrijgegeven.',
      },
      notFound: {
        title: 'Hier wacht geen kopie',
        description: 'De kopie is verlopen of al bezorgd. Is het verzoek nog open, dan maakt lumi een nieuwe en zie je die binnenkort weer in de lijst.',
      },
    },
  },
  legalNotices: {
    title: 'Privacy- en AI-mededeling voor medewerkers',
    intro: 'Wat deze werkruimte haar eigen medewerkers vertelt over privacy en het gebruik van AI op het werk.',
    titleLabel: 'Titel',
    contentLabel: 'Tekst van de mededeling',
    editMode: 'Bewerken',
    previewMode: 'Voorbeeld',
    state: {
      lumi: 'Hier staat de actuele tekst van lumi.',
      own: 'Hier staat je eigen tekst.',
      revisionCandidate: 'lumi heeft deze tekst herzien. Totdat je de herziene tekst overneemt, blijven kandidaten de huidige tekst lezen.',
      revisionEmployee: 'lumi heeft deze tekst herzien. Totdat je de herziene tekst overneemt, blijven medewerkers de huidige tekst lezen.',
      shownLumi: 'Dat is de eerdere tekst van lumi.',
      shownOwn: 'Dat is je eigen tekst.',
      unavailable: 'De actuele tekst van lumi kan nu niet worden gelezen.',
    },
    editText: 'Tekst aanpassen',
    diffOwn: 'Verschillen met de tekst van lumi',
    diffRevision: 'Verschillen bekijken',
    diffHide: 'Verschillen verbergen',
    returnToLumi: 'Terug naar de tekst van lumi',
    takeRevision: 'Overnemen',
    returnConfirm: { title: 'Terug naar de tekst van lumi?', body: 'Jouw tekst wordt in beide talen vervangen door de actuele tekst van lumi, met de gegevens van jouw workspace al ingevuld.' },
    takeConfirm: { title: 'De herziene tekst van lumi overnemen?', body: 'De actuele tekst van lumi vervangt de tekst in beide talen. Jouw gegevens – bedrijfsnaam, adres en meer – blijven ingevuld.' },
    diff: {
      label: 'Verschillen in de tekst',
      legend: 'Groen komt erbij met de actuele tekst van lumi, doorgestreept rood valt weg.',
      same: 'Geen verschil: de tekst is woordelijk gelijk aan de actuele tekst van lumi.',
      unchanged: '… {count} ongewijzigde alinea … | … {count} ongewijzigde alinea’s …',
      inserted: 'Toegevoegd:',
      removed: 'Verwijderd:',
    },
    adopted: 'lumi’s tekst overgenomen.',
    saved: 'Opgeslagen.',
    noticeRequired: 'De mededeling kan niet leeg worden opgeslagen.',
    lumiVersionUnavailable: 'lumi’s actuele tekst kon nu niet worden bereikt — probeer het zo weer.',
    forbidden: 'Je hebt geen toegang tot deze mededeling.',
    supportRefused: 'Een supportsessie geeft geen toegang tot deze mededeling.',
    membershipUnavailable: 'Je toegang kon nu niet worden gecontroleerd — probeer het zo weer.',
    loadFailed: 'De mededeling kon niet worden geladen.',
    blanksOpenRefusal: 'De tekst bevat nog openstaande velden: {list}. Vul ze hierboven in, of vervang ze door je eigen tekst, voordat je opslaat.',
    unsavedWarning: 'Je hebt je wijzigingen aan {name} nog niet opgeslagen.',
    demoDisclaimer: 'DIT IS DE DEMOVERSIE VOOR EEN FICTIEF DEMOBEDRIJF. GEEN JURIDISCH BINDEND DOCUMENT.',
    blanks: {
      lead: 'lumi’s sjablonen hebben deze gegevens van jou nodig. Vul elk gegeven één keer in – het wordt in alle teksten hieronder verwerkt, in beide talen.',
      saved: 'Opgeslagen.',
      complete: 'Alle vereiste gegevens zijn ingevuld.',
      suggested: 'Overgenomen uit je bedrijfsprofiel – controleer het en sla het dan op.',
      retentionOptions: { m3: '3 maanden', m6: '6 maanden', m12: '12 maanden' },
      retentionLineMissing: 'Je eigen tekst in {locales} noemt de bewaartermijn na een afwijzing niet meer. Er moet {words} in staan – pas de tekst aan en zet de zin terug.',
      retentionInvalid: 'Kies 3, 6 of 12 maanden.',
      retentionAnonymises: 'Vanaf deze keuze anonimiseert lumi afgewezen sollicitaties na deze termijn, ook de al afgewezen. Anonimiseren kan niet ongedaan worden gemaakt.',
      quoted: '„{text}”',
      whyLabel: 'Waarom',
      whereLabel: 'Waar het staat',
      keys: {
        company_name: {
          label: 'Bedrijfsnaam', hint: 'De officiële naam van deze workspace, zoals die in de kennisgeving moet verschijnen.',
          why: 'Een privacyverklaring moet zeggen wie verantwoordelijk is voor de gegevens.',
          where: 'In het onderdeel “Verwerkingsverantwoordelijke” van de privacyverklaring voor kandidaten, in de slotzin van de mededeling over AI-gebruik voor kandidaten en in het onderdeel “Verwerkingsverantwoordelijke” van de mededeling voor medewerkers – gelezen door kandidaten en medewerkers.',
        },
        company_address: {
          label: 'Bedrijfsadres', hint: 'Het postadres waarop medewerkers en sollicitanten je kunnen bereiken.',
          why: 'Wie een vraag of verzoek heeft, moet het verantwoordelijke bedrijf per post kunnen bereiken.',
          where: 'Direct achter de bedrijfsnaam, op dezelfde drie plekken.',
        },
        privacy_contact: {
          label: 'Contact gegevensbescherming', hint: 'Bij wie men terechtkan voor gegevensbescherming — een naam, een functie of een e-mailadres.',
          why: 'Betrokkenen moeten weten bij wie ze terechtkunnen voor gegevensbescherming en voor hun rechten.',
          where: 'In de zin “Voor vragen over gegevensbescherming kunt u terecht bij …” van de privacyverklaring voor kandidaten en de mededeling voor medewerkers, en in de alinea’s over rechten in alle drie de teksten – gelezen door kandidaten en medewerkers.',
        },
        applicant_retention: {
          label: 'Bewaartermijn na een afwijzing', hint: 'Dezelfde instelling als ATS ▸ Gegevensbescherming ▸ Automatische anonimisering: lumi anonimiseert afgewezen sollicitaties na deze termijn, dus de verklaring kan alleen beloven wat het product doet.',
          why: 'Een verklaring zonder termijn informeert niemand. Zolang er geen termijn is gekozen, geldt de privacyverklaring voor kandidaten als onvolledig en blijft het carrièreportaal offline.',
          where: 'In de zin “Bewaring na een afwijzing: …” van de privacyverklaring voor kandidaten – gelezen door kandidaten. Later pas je dit aan op deze pagina of onder ATS ▸ Gegevensbescherming.',
        },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Zo zijn je juridische teksten compleet',
      progress: '{done} van {total} klaar',
      facts: { title: 'Gegevens voor alle teksten', hint: 'Bedrijfsnaam, adres, contact voor gegevensbescherming en meer — ingevuld in elke tekst hieronder.' },
      imprintAction: 'Colofon invullen',
    },
    candidate: {
      heading: 'Mededelingen voor kandidaten',
      intro: 'De juridische mededelingen die deze werkruimte aan kandidaten toont op het vacatureportaal.',
      unavailable: 'De mededelingen voor kandidaten zijn nu niet beschikbaar.',
      noticeRequired: 'Deze verklaring wordt aan sollicitanten getoond en mag niet leeg zijn. Vervang de tekst of neem de versie van lumi over.',
      imprintRequired: 'Het colofon kan niet worden geleegd zolang het portaal online is. Vervang de tekst in plaats van die te wissen.',
      retentionLineRequired: 'De verklaring moet de bewaartermijn na een afwijzing noemen. Die komt uit de instelling voor verwijdering – laat “{words}” in de tekst staan.',
      privacy: {
        title: 'Tenant-specifieke privacyverklaring',
        subtitle: 'Deze versie wordt op het portaal getoond aan sollicitanten.',
      },
      aiUsage: {
        title: 'Kennisgeving over AI-gebruik voor kandidaten',
        subtitle: 'Deze tekst wordt aan kandidaten getoond op het carrièreportaal.',
      },
      imprint: {
        title: 'Colofon van het vacatureportaal',
        subtitle: 'Deze tekst wordt vanaf elke pagina van het portaal gelinkt.',
        hint: 'Een colofon is wettelijk verplicht (§ 5 DDG). Je vacatureportaal blijft offline zolang er in geen enkele taal een is opgeslagen.',
        fallsBack: 'Je colofon is opgeslagen. Talen zonder eigen colofon tonen op het portaal de {language}-versie.',
      },
      history: {
        title: 'Wat hebben we op een bepaalde datum getoond?',
        hint: 'Zoek de exacte tekst op die op een moment in het verleden op deze pagina stond — voor de vraag van een kandidaat of een toezichthouder.',
        open: 'Opzoeken',
        hide: 'Sluiten',
        dateLabel: 'Datum en tijd',
        localeLabel: 'Taal',
        lookUp: 'Tekst tonen',
        periodClosed: 'Live van {from} tot {until}.',
        periodOpen: 'Live sinds {from} — nog steeds de huidige tekst.',
        sourceLumi: 'lumi’s gepubliceerde versie {version}, woord voor woord.',
        sourceLumiUnversioned: 'lumi’s gepubliceerde tekst.',
        sourceTenant: 'De eigen tekst van deze werkruimte, afgesplitst van lumi-versie {version}.',
        sourceTenantOwn: 'De eigen tekst van deze werkruimte.',
        none: 'Zo ver reikt de registratie niet terug.',
        provenanceFollowing: 'Wat vaststaat: deze pagina is een kopie van lumi-versie {version} en is hier nooit overschreven.',
        provenanceBranched: 'Wat vaststaat: deze pagina komt uit lumi-versie {version} en is op {date} overschreven.',
        provenanceUnknown: 'Over de periode daarvoor is niets meer vastgelegd over deze pagina.',
        futureRefused: 'Deze registratie zegt wat een pagina heeft getoond, niet wat ze zal tonen. Kies een moment dat al voorbij is.',
        invalidRefused: 'Kies een datum en een taal voor de opzoeking.',
        failed: 'De registratie kon nu niet worden gelezen. Probeer het opnieuw.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Deze mededeling is op dit moment niet beschikbaar.',
  },
  dataImportHub: {
    segments: {
      import: 'Import',
      export: 'Export',
      label: 'Import of export',
    },
    umzug: {
      label: 'Je migratie',
      from: 'Migratie vanuit',
      pick: 'Migratie kiezen',
      files: '{count} bestand, laatste {when} | {count} bestanden, laatste {when}',
      startNew: 'Nieuwe migratie',
      nameIntro: 'Een migratie bundelt de bestanden uit hetzelfde systeem. Geef haar een naam, het liefst die van het oude systeem.',
      nameLabel: 'Naam van het oude systeem',
      nameHint: 'Kleine letters, cijfers, streepje en underscore; meer wordt niet bewaard.',
      namePlaceholder: 'bijv. personio',
      begin: 'Migratie beginnen',
      nameReserved: 'Lumi kan deze naam niet gebruiken. Kies een andere.',
      together: 'De bestanden van een migratie horen bij elkaar: latere bestanden vinden wat eerdere hebben aangemaakt. Eerst de basis, dan wat erop voortbouwt.',
    },
    order: 'Volgorde van de migratie',
    entries: {
      orgUnits: {
        title: 'Afdelingen & locaties',
        description: 'Afdelingen, teams, locaties en kostenplaatsen uit het oude systeem.',
        reason: 'Afdelingen en locaties zijn de basis voor al het andere.',
      },
      persons: {
        title: 'Medewerkers',
        description: 'Iedereen die bij je werkt, met stamgegevens, afdeling en leidinggevende.',
        reason: 'Je hebt de medewerkers nodig voor contracten, tijden en afwezigheid.',
      },
      contracts: {
        title: 'Contracten',
        description: 'Arbeidscontracten van de medewerkers.',
        needs: 'heeft de medewerkers nodig',
        reason: 'Contracten hangen aan de medewerkers.',
      },
      ats: {
        title: 'Vacatures, kandidaten & sollicitaties',
        description: 'Open en eerdere vacatures met hun kandidaten en sollicitaties.',
        needs: 'heeft de afdelingen & locaties nodig',
        reason: 'Vacatures verwijzen naar je locaties.',
      },
      time: {
        title: 'Klanten, projecten, tijden & afwezigheid',
        description: 'Klanten, projecten, geregistreerde tijden en afwezigheid.',
        needs: 'heeft de medewerkers nodig',
        reason: 'Tijden en afwezigheid horen bij de medewerkers.',
      },
    },
    state: {
      next: 'Als volgende.',
      imported: '{count} geïmporteerd · {file} · {when}',
      importedMany: '{count} geïmporteerd · {files} bestanden · laatste {when}',
      unfinished: 'Begonnen met {file}',
    },
    actions: {
      resume: 'Verdergaan',
      supplement: 'Aanvullen',
      continueHere: 'Hiermee verdergaan',
    },
    drop: {
      title: 'Sleep een bestand hierheen of kies er een',
      hint: 'CSV of Excel; een export uit het oude systeem volstaat.',
      after: 'Daarna:',
      savedLast: 'pas in de laatste stap wordt er iets opgeslagen',
    },
    ai: {
      label: 'Lumi verbetert de koppeling',
      infoLabel: 'Wat naar Lumi gaat',
      infoSent: 'Alleen de kolomnamen en hooguit 20 voorbeeldwaarden per kolom gaan naar de AI. Van kolommen waarvan de naam op gevoelige gegevens wijst, gaan geen waarden mee.',
      infoProposal: 'Het resultaat is slechts een voorstel: jij controleert en bevestigt elke koppeling zelf.',
      infoQuota: 'De verbetering telt mee voor je AI-tegoed.',
      quotaUsedUp: 'Geen AI-tegoed meer tot {date}.',
      quotaUsedUpNoDate: 'Geen AI-tegoed meer in deze periode.',
      suspended: 'Lumi is uitgeschakeld in deze werkruimte.',
      raise: 'Tegoed verhogen',
      withoutQuota: 'Op regels',
    },
    lock: {
      body: 'In {module} ontbreekt je het recht {permission}. Het hoort bij de rol {role}; suite-admin alleen is niet genoeg. Het wordt in Personeel onder {where} toegekend door iemand met de rol {granters}.',
      permissionImport: 'Gegevens importeren',
      permissionExport: 'Gegevens exporteren',
      accessPage: 'Rechten & toewijzingen',
      adminRole: '{module}-admin',
      granters: 'eigenaar of suite-beheerder',
      askSomeone: 'Vraag het iemand met de rol {role}.',
      grantSelf: 'Mezelf geven (Personeel → Rechten & toewijzingen)',
      mayManage: 'Je mag toegang beheren.',
    },
    lists: {
      imports: 'Imports in deze migratie ({count})',
      others: 'Andere migraties ({count})',
      show: 'Tonen',
      hide: 'Verbergen',
      noImports: 'In deze migratie is nog niets geïmporteerd.',
      noOthers: 'Geen andere migraties.',
      retention: 'Bestanden en rapporten worden 30 dagen na de import verwijderd; de overgenomen gegevens blijven.',
      report: 'Rapport',
      delete: 'Verwijderen',
      switchTo: 'Wisselen',
      you: 'jij',
      columns: {
        file: 'Bestand',
        entry: 'Onderdeel',
        result: 'Resultaat',
        when: 'Wanneer',
        by: 'Door',
      },
    },
    result: {
      done: 'Overgenomen',
      review: 'Te controleren',
      questions: 'Vragen open',
      reading: 'Wordt gelezen',
      checking: 'Wordt gecontroleerd',
      committing: 'Wordt overgenomen',
      cancelled: 'Geannuleerd',
      failed: 'Mislukt',
      created: '{count} nieuw',
      updated: '{count} bijgewerkt',
      unchanged: 'niets gewijzigd',
      toClarify: '{count} te verduidelijken',
    },
    done: {
      headline: 'Aangekomen in {module}: {count} {things}.',
      headlineRecords: 'Aangekomen in {module}: {count} records.',
      numbers: '{created} aangemaakt · {updated} bijgewerkt',
      notImported: '{count} rij niet overgenomen | {count} rijen niet overgenomen',
      leftOut: '{count} rij door jou overgeslagen | {count} rijen door jou overgeslagen',
      downloadList: 'Lijst downloaden',
      laterHint: ' (later is die niet meer beschikbaar)',
      skipped: '{count} rij ongewijzigd overgeslagen | {count} rijen ongewijzigd overgeslagen',
      soFar: 'Zo ver ben je',
      rowsIn: '{count} geïmporteerd',
      asNext: 'Als volgende: {reason}',
      whatNext: 'Hoe gaat het verder?',
      nextTitle: 'Verder met: {entry}',
      nextAction: 'Volgend bestand',
      orgChartTitle: 'Organigram bekijken',
      orgChartBody: 'Controleer of afdelingen en leidinggevenden zijn aangekomen zoals je ze kent.',
      orgChartBuildTitle: 'Organigram opbouwen',
      orgChartBuildBody: 'Iedereen leidt voorlopig zichzelf. Wie aan wie rapporteert, stel je nu in Personeel in.',
      accessTitle: 'Toegang geven',
      accessBody: 'De medewerkers zijn er, maar nog niemand kan inloggen. Toegang geef je in Personeel.',
      openPeople: 'Openen in Personeel',
    },
    export: {
      title: 'Export',
      intro: 'Haal je gegevens uit een module. Elke export draait onder jouw rechten in die module.',
      covers: {
        people: 'Medewerkers, afdelingen, contracten',
        ats: 'Vacatures, kandidaten, sollicitaties',
        time: 'Klanten, projecten, tijden, afwezigheid',
      },
      locked: 'In {module} ontbreekt je het recht {permission}. Het hoort bij de rol {role}.',
      last: 'Laatst geëxporteerd {when} · {count} items',
      none: 'Nog niet geëxporteerd.',
      past: 'Eerdere exports',
      columns: {
        module: 'Module',
        by: 'Door',
      },
      standard: 'Standaardexport',
      expired: 'Verlopen',
      archive: 'De {whole} vind je onder {link}.',
      archiveWhole: 'volledige gegevensset van de werkruimte',
    },
    run: {
      breadcrumb: 'Migratie vanuit {umzug} › {entry} · {file}',
    },
    nav: 'Data-import',
    title: 'Data-import & -export',
    locked: 'Geen rechten in deze module',
    plan: {
      failed: 'De extra gegevens konden niet worden aangemaakt.',
      companionErrors: 'Er zijn fouten opgetreden bij het aanmaken van de extra gegevens. Controleer ze in de module zelf.',
      projectionTimeout: 'De extra gegevens zijn nog niet in de doelmodule aangekomen. Probeer het later opnieuw.',
    },
    createField: {
      title: 'Nieuw eigen veld aanmaken',
      intro: 'Maak een eigen veld voor de kolom “{column}”. Het is daarna overal in het ATS beschikbaar.',
      typeHint: 'Keuzevelden (select/meervoudige selectie) maak je aan in het veldbeheer.',
      sensitiveNotImportable: 'Velden van bijzondere categorieën (art. 9) worden aangemaakt, maar zijn bewust geen importdoel.',
      submit: 'Veld aanmaken',
      label: 'Label',
      keyLabel: 'Veldsleutel (Key)',
      keyHint: 'Alleen kleine letters, cijfers en underscores',
      typeLabel: 'Type',
      types: {
        text: 'Tekst',
        textarea: 'Tekstveld',
        number: 'Getal',
        date: 'Datum',
        checkbox: 'Selectievakje',
      },
      sensitivityLabel: 'Welk soort gegevens bevat dit veld?',
      sensitivityUnanswered: 'Maak een keuze',
      sensitivityNone: 'Geen bijzondere categorie',
      sensitivityHint: 'Bijzondere categorieën van gegevens (art. 9 AVG) mogen geen geautomatiseerde beslissingen over een sollicitatie aansturen.',
      sensitivityCategories: {
        racialEthnic: 'Ras of etnische afkomst',
        politicalOpinion: 'Politieke opvattingen',
        religiousPhilosophical: 'Religieuze of levensbeschouwelijke overtuigingen',
        tradeUnion: 'Lidmaatschap van een vakbond',
        genetic: 'Genetische gegevens',
        biometricId: 'Biometrische identificatie',
        health: 'Gezondheidsgegevens',
        sexLifeOrientation: 'Seksueel leven of seksuele gerichtheid',
      },
      sensitivityRequired: 'Geef aan welk soort gegevens dit veld bevat.',
    },
    entities: {
      person: 'Medewerkers',
      orgUnit: 'Org-eenheden',
      employmentContract: 'Contracten',
      job: 'Vacatures',
      candidate: 'Kandidaten',
      application: 'Sollicitaties',
      client: 'Klanten',
      project: 'Projecten',
      timeEntry: 'Tijdregistraties',
      leaveRequest: 'Verlof',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      gender: {
        male: 'Man',
        female: 'Vrouw',
        diverse: 'Divers',
        undisclosed: 'Niet opgegeven',
      },
      maritalStatus: {
        single: 'Ongehuwd',
        married: 'Gehuwd',
        divorced: 'Gescheiden',
        widowed: 'Weduwe/weduwnaar',
        registered_partnership: 'Geregistreerd partnerschap',
        separated: 'Duurzaam gescheiden',
      },
      contractType: {
        permanent: 'onbepaalde tijd',
        fixed_term: 'bepaalde tijd',
        mini_job: 'minibaan',
        midi_job: 'midibaan (overgangsgebied)',
        working_student: 'werkstudent',
        apprenticeship: 'opleiding',
        internship: 'stage',
        freelance: 'freelance / op honorariumbasis',
        managing_director: 'directeur / bestuurder',
        other: 'overig',
      },
      workTimeArrangement: {
        full_time: 'voltijd',
        part_time: 'deeltijd',
        marginal: 'marginaal (minibaan)',
        variable: 'variabel / flexibel',
      },
      status: {
        draft: 'Concept',
        active: 'Actief',
        on_hold: 'Gepauzeerd',
        terminated: 'Beëindigd',
        inactive: 'Inactief',
      },
      type: {
        department: 'Afdeling',
        location: 'Locatie',
        team: 'Team',
        cost_center: 'Kostenplaats',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'Extern ID',
        type: 'Type',
        name: 'Naam',
        code: 'Code',
        description: 'Omschrijving',
        parentExternalId: 'Bovenliggende eenheid',
        parentCode: 'Bovenliggende eenheid (Code)',
        addressLine1: 'Adres',
        postalCode: 'Postcode',
        city: 'Plaats',
        country: 'Land',
        active: 'Actief',
      },
      person: {
        externalId: 'Extern ID',
        employeeNumber: 'Personeelsnummer',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        salutation: 'Aanhef',
        gender: 'Geslacht',
        email: 'E-mail',
        phone: 'Telefoon',
        birthDate: 'Geboortedatum',
        nationality: 'Nationaliteit',
        maritalStatus: 'Burgerlijke staat',
        addressLine1: 'Adres',
        addressLine2: 'Adrestoevoeging',
        postalCode: 'Postcode',
        city: 'Plaats',
        country: 'Land',
        workCountry: 'Werklocatie (land)',
        primaryLocale: 'Taal',
        status: 'Status',
        primaryOrgUnitExternalId: 'Afdeling / eenheid',
        primaryOrgUnitCode: 'Afdeling / eenheid (Code)',
        supervisorExternalId: 'Functioneel leidinggevende',
      },
      employmentContract: {
        externalId: 'Extern ID',
        personExternalId: 'Persoon',
        contractReference: 'Contractnummer',
        status: 'Contractstatus',
        startDate: 'Begindatum',
        endDate: 'Einddatum',
        probationEndDate: 'Einde proeftijd',
        contractType: 'Contracttype',
        position: 'Functie / werkzaamheden',
        primaryOrgUnitExternalId: 'Afdeling / eenheid',
        supervisorExternalId: 'Leidinggevende',
        workTimeArrangement: 'Arbeidsduur',
        weeklyHours: 'Uren per week',
        vacationDaysPerYear: 'Vakantierecht (dagen/jaar)',
        collectiveAgreementCode: 'Cao',
      },
    },
    // The ATS import's fields in the ATS UI's own words, per entity (the guided import,
    // issue 1063): the mapping step and the row errors name a field with these, never
    // by its key. Every key of ats-api's import-descriptor.ts has one in every locale.
    atsFields: {
      job: {
        externalId: 'Extern ID',
        title: 'Functietitel',
        departmentName: 'Afdeling',
        locationName: 'Locatie',
        state: 'Status',
        headcount: 'Aantal plaatsen',
        employmentType: 'Soort dienstverband',
        requiredSkills: 'Vereiste vaardigheden',
      },
      candidate: {
        externalId: 'Extern ID',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        email: 'E-mail',
        phone: 'Telefoon',
        skills: 'Vaardigheden',
        availableFrom: 'Beschikbaar vanaf',
        noticePeriodDays: 'Opzegtermijn (dagen)',
        remotePreference: 'Voorkeur werklocatie',
        salaryExpectation: 'Salarisverwachting (per jaar)',
        seniority: 'Ervaringsniveau',
        poolTags: 'Talentenpool-tags',
      },
      application: {
        externalId: 'Extern ID',
        candidateExternalId: 'Kandidaat',
        jobExternalId: 'Vacature',
        state: 'Fase',
        appliedAt: 'Gesolliciteerd op',
        note: 'Notitie',
      },
    },
    // The ATS descriptor's fixed enum values in the ATS UI's words (the workflow states and
    // the department/location names are the workspace's own and need none).
    atsValues: {
      remotePreference: {
        onsite: 'Op locatie',
        hybrid: 'Hybride',
        remote: 'Op afstand',
      },
      seniority: {
        junior: 'Junior',
        mid: 'Medior',
        senior: 'Senior',
        lead: 'Lead',
      },
    },
    // Time's import fields in Time's own words, per entity (see atsFields).
    timeFields: {
      client: {
        externalId: 'Extern ID',
        name: 'Naam',
        isInternal: 'Intern',
      },
      project: {
        externalId: 'Extern ID',
        name: 'Projectnaam',
        clientExternalId: 'Klant',
        externalRef: 'Projectreferentie',
        description: 'Omschrijving',
        status: 'Status',
        isBillable: 'Factureerbaar',
        hourlyRate: 'Uurtarief',
        budgetHours: 'Urenbudget',
      },
      timeEntry: {
        externalId: 'Extern ID',
        userEmail: 'E-mail van de persoon',
        personnelNumber: 'Personeelsnummer',
        date: 'Datum',
        startTime: 'Begintijd',
        endTime: 'Eindtijd',
        durationMinutes: 'Duur (minuten)',
        bookingType: 'Boekingstype',
        projectExternalId: 'Project',
        activity: 'Activiteit',
        note: 'Notitie',
        status: 'Status',
      },
      leaveRequest: {
        externalId: 'Extern ID',
        userEmail: 'E-mail van de persoon',
        personnelNumber: 'Personeelsnummer',
        leaveType: 'Soort verlof',
        startDate: 'Van',
        endDate: 'Tot en met',
        status: 'Status',
        note: 'Notitie',
      },
    },
    // Time's enum values. `status` is shared by projects, time entries and absences, so it
    // carries the union of their values (the value maps are keyed by field, per module).
    timeValues: {
      status: {
        active: 'Actief',
        closed: 'Gesloten',
        paused: 'Gepauzeerd',
        completed: 'Afgerond',
        archived: 'Gearchiveerd',
        draft: 'Concept',
        submitted: 'Ingediend',
        approved: 'Goedgekeurd',
        pending: 'In afwachting',
        rejected: 'Afgewezen',
      },
      leaveType: {
        vacation: 'Vakantie',
        special: 'Buitengewoon verlof',
        parental: 'Ouderschapsverlof',
        unpaid: 'Onbetaald verlof',
        training: 'Opleiding',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Type actor' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Rollen', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Herhaalde mislukte inlogpogingen', locked: 'Account vergrendeld' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Account ontgrendeld', disabled: 'Account uitgeschakeld', enabled: 'Account ingeschakeld', closed: 'Account gesloten' }, passkey: { revoked: 'Passkeys verwijderd door een beheerder' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Eigendom overgedragen', member_removed: 'Lid verwijderd', suite_roles_changed: 'Suite-rollen gewijzigd' }, tenant: { created: 'Tenant aangemaakt', lifecycle: 'Tenant lifecycle change', exported: 'Tenant geëxporteerd' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'AI-instellingen gewijzigd' }, tenant_role_editing: { changed: 'Rollen bewerken gewijzigd' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Installatie gekozen', demo_started: 'Demomodus gestart', demo_seeded: 'Demogegevens aangemaakt', demo_seed_failed: 'Aanmaken van demogegevens mislukt', demo_wipe_started: 'Wissen van demo gestart', demo_wiped: 'Demogegevens gewist', demo_wipe_failed: 'Wissen van demogegevens mislukt', setup_finished: 'Installatie voltooid', demo_denied: 'Demomodus geweigerd', module_topup: 'Demogegevens toegevoegd voor nieuwe module', demo_reset_started: 'Resetten van demo gestart', demo_tier_switch_started: 'Overstap naar volledige demo gestart', demo_rebuilt: 'Demo opnieuw opgebouwd' }, company_profile: { created: 'Bedrijfsprofiel aangemaakt', updated: 'Bedrijfsprofiel bijgewerkt' }, org_scenario: { activated: 'Organisatiescenario geactiveerd' }, people_data: { wiped: 'Personeelsgegevens gewist' }, ats_data: { wiped: 'Recruitmentgegevens gewist' }, time_data: { wiped: 'Tijdregistratiegegevens gewist' }, apprentice_data: { wiped: 'Opleidingsgegevens gewist' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Betaling geïnd', failed: 'Betaling mislukt', refunded: 'Betaling terugbetaald', chargeback: 'Chargeback ontvangen' }, invoice: { issued: 'Factuur uitgegeven' }, mandate: { created: 'Kaart toegevoegd', replaced: 'Kaart vervangen' }, promo_code: { redeemed: 'Actiecode ingewisseld' }, billing_account: { converted: 'Proefperiode omgezet naar betaald', delinquent: 'Account achterstallig', purged: 'Facturatiegegevens gewist' }, dunning_case: { opened: 'Incasso gestart' }, enforcement: { opened: 'Handhaving gestart', advanced: 'Handhaving geëscaleerd', cleared: 'Handhaving opgeheven' }, billing_exempt: { changed: 'Facturatievrijstelling gewijzigd' }, billing_data: { wiped: 'Facturatiegegevens gewist', generated: 'Test-facturatiegegevens gegenereerd' }, checkout: { completed: 'Bestelling voltooid', denied: 'Bestelling geweigerd' }, job: { created: 'Vacature aangemaakt', updated: 'Vacature bijgewerkt', submitted: 'Vacature ingediend', archived: 'Vacature gearchiveerd', deleted: 'Vacature verwijderd' }, application: { created: 'Sollicitatie ontvangen', updated: 'Sollicitatie bijgewerkt', transitioned: 'Sollicitatiestatus gewijzigd', withdrawn: 'Sollicitatie ingetrokken', transferred: 'Sollicitatie verplaatst naar andere vacature', transfer_declined: 'Verplaatsing van sollicitatie geweigerd', rejected: 'Sollicitatie afgewezen', deleted: 'Sollicitatie verwijderd', emailed: 'Sollicitatie-e-mail verzonden' }, interview: { proposed: 'Interview voorgesteld', confirmed: 'Interview bevestigd', cancelled: 'Interview geannuleerd' }, candidate: { anonymized: 'Kandidaat geanonimiseerd', emailed: 'E-mail naar kandidaat verzonden', identity_changed: 'Kandidaatgegevens gewijzigd', identity_split: 'Kandidaat losgekoppeld op eigen profiel', identity_merged: 'Sollicitatie verplaatst naar de kandidaat met dit adres' }, candidate_dossier: { accessed: 'Kandidaat heeft eigen gegevens bekeken' }, workflow: { deleted: 'Workflow verwijderd', definition: { published: 'Workflow gepubliceerd' } }, task: { blocking_overridden: 'Blokkerende taak genegeerd', auto_cancelled: 'Taak automatisch geannuleerd' }, support_access: { requested: 'Supporttoegang aangevraagd', approved: 'Supporttoegang goedgekeurd', denied: 'Supporttoegang geweigerd', revoked: 'Supporttoegang beëindigd', expired: 'Supporttoegang verlopen', request_expired: 'Verzoek om supporttoegang verlopen' }, ai_action: { executed: 'AI-actie uitgevoerd' }, assistant_run: { proposed: 'lumi stelde een actie voor', approved: 'lumi-actie goedgekeurd', refused: 'lumi-actie geweigerd', failed: 'lumi-actie mislukt' }, assistant_turn: { fanned_out: 'lumi-verzoek verdeeld over meerdere modules' }, payroll_export_run: { created: 'Salarisexport gestart', completed: 'Salarisexport voltooid', failed: 'Salarisexport mislukt', downloaded: 'Salarisexport gedownload' }, payroll_period: { closed: 'Salarismaand afgesloten', reopened: 'Salarismaand heropend' }, payroll_connection: { updated: 'Salariskoppeling gewijzigd' }, payroll_master_data: { exported: 'Salarisstamgegevens geëxporteerd' }, wage_type: { created: 'Looncomponent aangemaakt', updated: 'Looncomponent bijgewerkt', deleted: 'Looncomponent verwijderd', starter_catalog_applied: 'Standaard looncomponenten toegevoegd' }, wage_assignment: { created: 'Loonbestanddeel toegevoegd', updated: 'Loonbestanddeel gewijzigd', deleted: 'Loonbestanddeel verwijderd' }, one_time_payment: { created: 'Eenmalige betaling toegevoegd', updated: 'Eenmalige betaling gewijzigd', deleted: 'Eenmalige betaling verwijderd' }, payslip: { filed: 'Loonstroken gearchiveerd' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Verbind je identity provider (OIDC) zodat je team zich daarmee aanmeldt.',
    issuerUrl: 'Issuer-URL (OIDC-discovery)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Laat leeg om het opgeslagen secret te behouden',
    label: 'Weergavenaam',
    allowedDomains: 'Toegestane e-maildomeinen (kommagescheiden)',
    jitEnabled: 'Gebruikers automatisch aanmaken bij eerste aanmelding (JIT)',
    jitDefaults: 'Standaard moduletoegang voor nieuwe gebruikers',
    jitModulePlaceholder: 'Kies een module',
    jitRoles: 'Rollen',
    jitCatalogUnreadable: 'De rollen van deze module konden niet worden gelezen. De opgeslagen rollen blijven ongewijzigd.',
    jitUnknownRole: '{key} (onbekend)',
    addJit: 'Module toevoegen',
    remove: 'Remove',
    redirectUri: 'Redirect-URI (registreer deze in je IdP)',
    copy: 'Kopiëren',
    test: 'Verbinding testen',
    testOk: 'Discovery geslaagd.',
    testFailed: 'Test mislukt',
    save: 'Opslaan',
    saved: 'Opgeslagen.',
    delete: 'Verbinding verwijderen',
    deleteConfirm: 'Deze SSO-verbinding echt verwijderen?',
    enforce: 'Aanmelden alleen via SSO afdwingen',
    enforceHint: 'Aanmelden met wachtwoord is uitgeschakeld voor iedereen behalve systeembeheerders en de eigenaar van de workspace.',
    noConnection: 'Er is nog geen SSO-verbinding geconfigureerd.',
    deleted: 'Verbinding verwijderd.',
    enforceEnabled: 'Aanmelden kan nu alleen nog via SSO.',
    enforceDisabled: 'Aanmelden met wachtwoord kan weer.',
    jitNeedsVerifiedDomain: 'Gebruikers worden alleen automatisch aangemaakt voor adressen op een bevestigd domein.',
    domainsTitle: 'E-maildomeinen',
    domainsIntro: 'Een domein telt pas mee voor SSO-aanmelding als je hebt aangetoond dat het van jullie is: publiceer dit TXT-record in de DNS van het domein en controleer het daarna. Accounts die al gekoppeld zijn, melden zich intussen gewoon aan.',
    domainStatus: { pending: 'Niet bevestigd', verified: 'Bevestigd', legacy: 'Binnenkort bevestigen' },
    domainLegacyUntil: 'Bevestigen vóór {date}',
    domainRecordName: 'Recordnaam (TXT)',
    domainRecordValue: 'Recordwaarde',
    domainVerify: 'Record controleren',
    domainVerified: '{domain} is bevestigd.',
    domainError: { record_not_found: 'Onder deze naam is nog geen TXT-record gevonden. DNS-wijzigingen kunnen even duren.', value_mismatch: 'Er is een TXT-record, maar de waarde klopt niet. Kopieer de waarde precies.', dns_error: 'De DNS-opvraging is mislukt. Probeer het over een paar minuten opnieuw.' },
  },  users: { seatLimit: { bookMore: 'Alle {booked} geboekte gebruikersplaatsen zijn bezet. Boek minstens {required} gebruikersplaatsen om iemand anders uit te nodigen.', leaveFreelancer: 'Deze workspace staat in de freelancemodus: één persoon, één plaats. Als je de freelancemodus verlaat, boek je {required} gebruikersplaatsen en is er plek voor de mensen die je uitnodigt.', notified: 'Alle {booked} geboekte gebruikersplaatsen zijn bezet. De workspace-eigenaar en de Billing Managers kunnen meer plaatsen boeken.', cta: 'Meer plaatsen boeken' }, removeSuccess: '{email} is uit deze workspace verwijderd.', saveSuccess: 'Toegangswijzigingen voor {email} opgeslagen.', saveFailedFor: 'Kon {targets} voor {email} niet opslaan: {reason}', saveFailedOthersSaved: 'De overige wijzigingen zijn opgeslagen.', suiteRolesTarget: 'de suite-rollen', unsaved: 'Niet opgeslagen', defaultRoleHint: 'Standaardrol voor interne uitnodigingen', refreshFailed: 'De ledenlijst kon niet worden vernieuwd. Laad de pagina opnieuw om de opgeslagen staat te zien.', title: 'Gebruikers & Toewijzingen', email: 'E-mail', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Workspace-admin: beheert leden, moduletoegang, SSO en beveiliging.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Kan de facturering beheren (facturen, kaart, plan).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Behandelt supporttickets (beantwoorden, escaleren, sluiten).', suiteDataProtection: 'Functionaris gegevensbescherming', suiteDataProtectionHint: 'Beoordeelt en keurt verzoeken van betrokkenen en verwijderingen goed en kan ledengegevens in elke actieve module inzien.', suiteOwnerLocked: 'De workspace-eigenaar is altijd Admin.', saveFailed: 'Toewijzing kon niet worden opgeslagen', inviteSuccess: '{email} is succesvol uitgenodigd', invite: { titleInternal: 'Lid uitnodigen', titleExternal: 'Extern uitnodigen', hintInternal: 'Krijgt automatisch de standaardrol in Tijd en Personeel — je kunt meteen na het uitnodigen extra rollen toevoegen.', hintExternal: 'Geen standaardrollen: zonder rol heeft deze persoon geen toegang tot een module. Stel de toegang meteen na het uitnodigen in.', submit: 'Uitnodigen', sentTitle: 'Uitnodiging verzonden', sentLead: '{email} is uitgenodigd en verschijnt als Uitgenodigd.', sentBodyInternal: 'Heeft al de standaardrol in Tijd en Personeel.', sentBodyExternal: 'Nog zonder rollen — stel in waar deze persoon toegang toe krijgt.', revoke: 'Uitnodiging intrekken', moreRoles: 'Meer rollen', setupRoles: 'Rollen instellen', done: 'Klaar', revokedTitle: 'Uitnodiging ingetrokken', revokedBody: '{email} is verwijderd uit de workspace. De uitnodigingslink is niet meer geldig.' }, removeUser: 'Verwijderen', confirmRemove: 'Weet je zeker dat je {email} uit deze tenant wilt verwijderen? Alle moduletoewijzingen worden verwijderd.', statusActive: 'Actief', statusInvited: 'Uitgenodigd', statusDisabled: 'Uitgeschakeld', transferOwnership: 'Eigendom overdragen', transferTitle: 'Eigendom van de workspace overdragen', transferIntro: '{from} draagt deze workspace over aan {to}. Er is precies één eigenaar: zodra je bevestigt, is {from} dat niet meer.', transferConsequences: 'Dit verandert:', transferConsequenceBreakGlass: 'De nood-login bij een SSO-storing gaat naar {to}: is jullie identity provider onbereikbaar, dan kan {to} nog met een wachtwoord inloggen, {from} niet meer.', transferConsequenceOutgoing: '{from} behoudt alle rollen die diegene al heeft, inclusief Admin — alleen het eigendom verandert. {from} kan net als elk ander lid worden uitgeschakeld of verwijderd.', transferConsequenceSuiteAdmin: '{to} krijgt de rol Admin als die nog ontbreekt. Niemand raakt een rol kwijt.', transferSsoWarning: '{email} logt in via SSO en heeft geen wachtwoord. Als SSO niet beschikbaar is, kan de overgenomen noodtoegang niet worden gebruikt; een wachtwoord instellen kan altijd via “Wachtwoord vergeten”.', transferBlockedPending: '{email} heeft de uitnodiging nog niet geaccepteerd. Dat moet eerst gebeuren.', transferBlockedDisabled: 'Het account van {email} is uitgeschakeld. Schakel het weer in voordat je het eigendom overdraagt.', transferConfirmFieldLabel: 'Bevestig de nieuwe eigenaar', transferConfirmHint: 'Typ {email} om de knop vrij te geven.', transferSuccess: '{email} is nu eigenaar van deze workspace.', transferFailed: 'Het eigendom kon niet worden overgedragen. Probeer het opnieuw.', transferErrorForbidden: 'Alleen de huidige eigenaar kan het eigendom overdragen.', transferErrorNotMember: '{email} is geen lid meer van deze workspace.', transferErrorAlreadyOwner: '{email} is al eigenaar van deze workspace.', transferErrorRaced: 'Het eigendom is gewijzigd terwijl deze overdracht liep. Herlaad de lijst en probeer het opnieuw.', transferErrorIneligible: '{email} kan het eigendom nu niet overnemen. Ververs de lijst voor de actuele status.', resendInvite: 'Uitnodiging opnieuw versturen', disable: 'Uitschakelen', enable: 'Inschakelen', confirmDisable: '{email} uitschakelen? De persoon wordt direct afgemeld en kan pas weer inloggen als je het account opnieuw inschakelt.', resendSuccess: 'Uitnodiging opnieuw verstuurd naar {email}.', resendEmailFailed: 'De uitnodigingsmail naar {email} kon niet worden verzonden. Probeer het opnieuw.', disableSuccess: '{email} is uitgeschakeld.', enableSuccess: '{email} is ingeschakeld.', inviteEmailFailed: '{email} is toegevoegd, maar de uitnodigingsmail kon niet worden verzonden. Je kunt deze opnieuw versturen.', searchPlaceholder: 'Zoeken op e-mail', rolesFilterPlaceholder: 'Filteren op rol', clearRolesFilter: 'Filter wissen', memberCount: '{count} leden', memberCountFiltered: '{shown} van {count} leden', inviteInternal: 'Uitnodigen', inviteExternal: 'Extern uitnodigen', removeRoleFilter: 'Rol uit filter verwijderen', columns: { account: 'Account', status: 'Status', roles: 'Rollen' },moduleNames: { ats: 'Werving', time_tracking: 'Tijd', people: 'Personeel', apprenticeship: 'Ausbildung' }, accessDenied: 'Geen toegang', moreActions: 'Meer acties voor {email}', noSearchResults: 'Geen lid komt overeen met ‘{query}’.', editSubtitle: 'Rollen en toegang bewerken', suiteConfirmGrantTitle: 'Suite-rol toekennen?', suiteConfirmRevokeTitle: 'Suite-rol intrekken?', suiteConfirmMixedTitle: 'Suite-rollen wijzigen?', suiteConfirmLead: 'Dit verandert voor {email}:', suiteConfirmRemoved: 'Verliest {role}.', suiteConfirmAccept: 'Ja, opslaan' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'AI-agent koppelen',
    heading: 'Een AI-agent wil namens u handelen',
    intro: 'Een AI-client die zich ‘{client}’ noemt, vraagt om in lumi namens u te werken, in de workspace {workspace}.',
    fields: {
      client: 'Noemt zich',
      redirectHost: 'Stuurt u terug naar',
      website: 'Opgegeven website',
      workspace: 'In de workspace',
    },
    scopesHeading: 'Hij vraagt om:',
    scope: {
      read: 'Lezen wat u in lumi kunt zien',
      act: 'Acties namens u voorstellen en uitvoeren — elke actie vraagt om uw bevestiging',
      ask: 'Vragen stellen aan lumi',
    },
    meaning: {
      heading: 'Wat ‘Toestaan’ betekent',
      asYou: 'Hij handelt als u, met precies uw rechten in deze workspace — nooit meer.',
      egress: 'Alles wat hij in lumi leest, gaat naar de aanbieder achter ‘{client}’, buiten lumi.',
      revocable: 'U kunt de koppeling op elk moment beëindigen op uw accountpagina.',
    },
    standing: {
      label: 'Acties op mijn eigen gegevens uitvoeren zonder elke keer te vragen',
      hint: 'Geldt nooit voor gegevens van anderen of voor nadelige beslissingen — daarvoor wordt altijd gevraagd. U kunt dit op elk moment wijzigen op uw accountpagina.',
    },
    rolePins: {
      title: 'Rol per module',
      hint: 'Waar u meer dan één rol hebt, kiest u de rol waarin de agent werkt. Hij kan nooit meer dan die rol toestaat.',
      default: 'Standaard van de module ({rule})',
      defaultRule: {
        first_assigned: 'uw eerst toegewezen rol',
        first_by_key: 'uw eerste rol op sleutel',
        all_roles: 'al uw rollen samen',
      },
      modules: {
        ats: 'Werving',
        time: 'Tijd',
        people: 'Personeel',
      },
      notHeld: 'U hebt de gekozen rol in die module niet meer. Kies opnieuw.',
    },
    disabled: {
      title: 'Externe AI-agents zijn in deze workspace uitgeschakeld',
      body: 'Een eigenaar of beheerder kan ze inschakelen onder Beheer → Externe AI-agents. Tot dan kunt u dit verzoek alleen weigeren.',
    },
    actions: {
      allow: 'Toestaan',
      deny: 'Weigeren',
    },
    returning: 'U wordt teruggestuurd naar {client}…',
    invalid: {
      title: 'Dit aanmeldverzoek is niet meer geldig',
      hint: 'Start de koppeling opnieuw vanuit uw AI-client.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Externe AI-agents',
    cardTitle: 'Externe AI-agents',
    noAccess: 'Geen toegang',
    noAccessHint: 'Alleen de eigenaar van de workspace en suitebeheerders kunnen deze instelling wijzigen.',
    intro: 'Als dit is ingeschakeld, kunnen leden hun eigen AI-client koppelen — Claude Code, OpenClaw, … — en die namens hen laten handelen in deze workspace.',
    points: {
      asMember: 'Een agent werkt met precies de rechten van het lid dat hem heeft gekoppeld — nooit meer.',
      confirmed: 'Elke actie die hij voorstelt, bevestigt dat lid voordat ze plaatsvindt.',
      adverse: 'Nadelige beslissingen over anderen vragen altijd om het lumi-paneel; een agent kan ze nooit bevestigen.',
    },
    egress: {
      title: 'Waar de gegevens van leden naartoe gaan',
      body: 'Alles wat een agent leest, gaat naar de AI-client die het lid koppelt — een ontvanger buiten de verwerkersketen van lumi, gekozen door uw workspace en het lid.',
      worksCouncil: 'Of leden zulke clients mogen gebruiken, beslist u als werkgever — overweeg uw ondernemingsraad te betrekken.',
    },
    switchLabel: 'Leden toestaan externe AI-agents te koppelen',
    saving: 'Opslaan…',
    activeConnections: 'Geen actieve koppeling. | 1 actieve koppeling. | {n} actieve koppelingen.',
    offHint: 'Uitschakelen beëindigt meteen elke koppeling in deze workspace.',
    roleNote: 'Alleen de eigenaar van de workspace of een suitebeheerder kan dit wijzigen.',
    savedOn: 'Externe AI-agents zijn ingeschakeld. Leden kunnen nu hun AI-client koppelen.',
    savedOff: 'Externe AI-agents zijn uitgeschakeld. | Externe AI-agents zijn uitgeschakeld. 1 koppeling is beëindigd. | Externe AI-agents zijn uitgeschakeld. {n} koppelingen zijn beëindigd.',
    disableConfirm: {
      title: 'Externe AI-agents uitschakelen?',
      body: 'Er is nu geen actieve koppeling; leden kunnen daarna niet meer koppelen. | Dit beëindigt meteen 1 koppeling. | Dit beëindigt meteen {n} koppelingen.',
      confirm: 'Uitschakelen',
    },
  },
  supportAccess: {
    revokeConfirm: 'De supporttoegang eindigt meteen. Het supportteam verliest de toegang tot deze werkruimte.',
    title: 'Supporttoegang',
    subtitle: 'Tijdelijke, door u goedgekeurde toegang tot uw workspace voor ons supportteam.',
    noAccess: 'Geen toegang',
    noAccessHint: 'Alleen de eigenaar van de workspace en suitebeheerders kunnen deze verzoeken beoordelen.',
    empty: 'Geen supporttoegang aangevraagd',
    emptyHint: 'Als onze support toegang tot uw workspace nodig heeft voor een ticket, verschijnt het verzoek hier.',
    pendingTitle: 'Toegangsverzoek open',
    pendingIntro: '{supporter} vraagt {days} dagen toegang tot deze workspace.',
    activeTitle: 'Supporttoegang is actief',
    activeIntro: '{supporter} kan momenteel in deze workspace werken.',
    historyTitle: 'Geschiedenis',
    revokeHint: 'Beëindigen werkt binnen een minuut.',
    expiringNow: 'Verloopt nu',
    remainingDays: 'nog {days} d {hours} u',
    remainingHours: 'nog {hours} u {minutes} min',
    remainingMinutes: 'nog {minutes} min',
    fields: {
      requestedAt: 'Aangevraagd',
      ticket: 'Supportticket',
      duration: 'Duur',
      durationValue: '{days} dagen',
      reason: 'Opgegeven reden',
      approvedBy: 'Goedgekeurd door',
      expiresAt: 'Verloopt',
      remaining: 'Resterende tijd',
      grantedModules: 'Toegekende rollen',
    },
    consent: { allRoles: 'De supportmedewerker kan naar elke rol van deze modules wisselen — die ziet wat uw medewerkers zien, niet alleen de beheerdersweergave.', modulesHeading: 'Deze toegang omvat:', via: 'via {module}',
      heading: 'Wat u goedkeurt',
      data: 'Support kan bij de gegevens van deze workspace in alle actieve modules, inclusief persoonsgegevens van medewerkers en kandidaten.',
      audited: 'Elke actie wordt vastgelegd in uw auditlog en gemarkeerd als supportactie.',
      duration: 'De toegang eindigt automatisch na {days} dagen.',
      revocable: 'U kunt hem altijd beëindigen; dat werkt binnen een minuut.',
    },
    actions: { approve: 'Toegang goedkeuren', deny: 'Weigeren', revoke: 'Nu beëindigen' },
    status: {
      requested: 'Open',
      active: 'Actief',
      denied: 'Geweigerd',
      revoked: 'Beëindigd',
      expired: 'Verlopen',
      request_expired: 'Verzoek verlopen',
    },
    columns: { supporter: 'Supportaccount', requestedAt: 'Aangevraagd', status: 'Status', endedAt: 'Beëindigd' },
    success: { approved: 'Supporttoegang goedgekeurd.', denied: 'Verzoek geweigerd.', revoked: 'Supporttoegang beëindigd.' },
    errors: {
      consentChanged: 'De toestemmingstekst is gewijzigd. Lees hem opnieuw voordat u goedkeurt.',
      selfApproval: 'Het aanvragende account kan zijn eigen verzoek niet goedkeuren.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Wettelijke regels en afspraken',
    intro: 'De wettelijke regels gelden automatisch en worden centraal actueel gehouden. Hier leg je alleen vast waar je bedrijf ervan afwijkt – elke afwijking heeft een grondslag nodig, bijvoorbeeld een cao of een bedrijfsregeling.',
    disclaimer: 'Richtwaarden volgens de wet – geen juridisch advies. Cao’s kunnen strenger zijn.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Nog niet gecontroleerd',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi start met de wettelijke standaardregels. Passen ze bij jullie, bevestig dat dan. Geldt er bij jullie een cao of een bedrijfsovereenkomst, maak dan hieronder een afwijking aan.',
        confirm: 'Gecontroleerd, past bij ons',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi start met de wettelijke standaardregels – maximale arbeidstijd, pauzes, rusttijd. Bepaal wat er gebeurt als een boeking een regel overtreedt en bevestig daarna dat de regels bij jullie passen.',
        standard: 'Standaard',
        later: 'Je kunt beide later altijd aanpassen.',
        agreements: 'Geldt er bij jullie een cao of een bedrijfsovereenkomst waarbij een regel anders of helemaal niet geldt? Maak dan hieronder een {basis} aan – de waarschuwingen richten zich daarnaar. Een modus zonder waarschuwingen bestaat niet.',
        agreementsBasis: 'afwijking met haar grondslag',
        flexible: {
          personLabel: 'De persoon', personText: 'ziet bij het opslaan welke regel met hoeveel is overtreden – de boeking blijft staan.',
          managerLabel: 'De leidinggevende', managerText: 'ziet de overtredingen van de week bij de goedkeuring en beslist samen met de persoon.',
          recordLabel: 'Het logboek', recordText: 'legt elke overtreding vast – voor jullie, niet tegen jullie.',
        },
        strict: {
          personLabel: 'De persoon', personText: 'kan een boeking die een afgedwongen regel overtreedt niet opslaan – en ziet waarom. Een ontbrekende pauze wordt wel opgeslagen en getoond.',
          managerLabel: 'De leidinggevende', managerText: 'ziet bij de goedkeuring alleen wat toch ontstaat: ontbrekende pauzes en automatische afsluitingen.',
          fitLabel: 'Past als', fitText: 'uitzonderingen bij jullie niet mogen voorkomen – bijvoorbeeld bij minderjarigen.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Opgeslagen. Daarmee zijn de arbeidstijdregels nog niet bevestigd – bevestig nu dat ze bij jullie passen.', confirm: 'Nu bevestigen' },
      confirmed: { title: 'Gecontroleerd', body: 'Op {date} door {name} bevestigd: de wettelijke regels passen bij ons.', bodyNoName: 'Op {date} bevestigd: de wettelijke regels passen bij ons.' },
      ownDeviation: { title: 'Gecontroleerd', body: 'Jullie workspace heeft eigen afwijkingen, dus de regels zijn bekeken.' },
      error: 'De bevestiging kon niet worden opgeslagen. Probeer het opnieuw.',
    },
    noJurisdictions: 'Er is nog geen rechtsgebied vastgelegd: er zijn geen personen met een werklocatie en er is geen standaardrechtsgebied. Kies hieronder een standaard, dan verschijnen hier de wettelijke regels.',
    jurisdictionEu: 'EU-richtlijn',
    jurisdictionDefault: '{name} (standaard)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Rechtsgebied {country}: deze regels gelden nu voor niemand. | Rechtsgebied {country}: deze regels beoordelen de arbeidstijd van 1 persoon in Tijd die hier werkt. | Rechtsgebied {country}: deze regels beoordelen de arbeidstijd van {count} personen – alle actieve medewerkers in Tijd die hier werken.',
    headcountLineDefault: 'Rechtsgebied {country}: deze regels gelden nu voor niemand. | Rechtsgebied {country}: deze regels beoordelen de arbeidstijd van 1 persoon in Tijd die hier werkt of onder het standaard rechtsgebied valt. | Rechtsgebied {country}: deze regels beoordelen de arbeidstijd van {count} personen – alle actieve medewerkers in Tijd die hier werken of onder het standaard rechtsgebied vallen.',
    fallbackLine: 'Personen zonder werklocatie, of met een werklocatie buiten de catalogus: {count} – voor hen geldt {country}.',
    createModels: 'Werktijdmodellen van dit land aanmaken',
    domains: {
      workingTime: 'Arbeidstijd',
      pay: 'Tijdvakken voor toeslagen',
      overtime: 'Overwerk',
      leave: 'Verlof',
    },
    rules: {
      maxDailyHours: 'Maximale arbeidstijd per dag',
      maxWeeklyHours: 'Maximale arbeidstijd per week',
      breaks: 'Pauzes',
      minDailyRest: 'Dagelijkse rusttijd',
      nightWorkBan: 'Verbod op nachtarbeid',
      minWeeklyRest: 'Wekelijkse rusttijd',
      avgWeeklyHours: 'Gemiddelde arbeidstijd per week',
      normalDailyHours: 'Normale arbeidstijd per dag',
      normalWeeklyHours: 'Normale arbeidstijd per week',
      nightWindow: 'Nachtperiode voor toeslagen',
      nightCoreWindow: 'Kernnacht voor hogere toeslagen',
      overtimeThreshold: 'Overwerk vanaf (uren per week)',
      overtimeSurcharge: 'Overwerktoeslagen',
      minLeaveDays: 'Minimaal verlof per jaar',
    },
    kinds: {
      collectiveAgreement: 'Cao',
      worksAgreement: 'Bedrijfsregeling',
      authorityPermit: 'Ontheffing van de inspectie',
      companyPolicy: 'Bedrijfsbeleid',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} dagen',
      breakStage: '{minutes} min vanaf {hours} uur',
      weeklyAverage: '{hours} uur gemiddeld over {weeks} weken',
      nightWorkBan: 'geen werk tussen {start} en {end} uur',
      tierFirst: '{percent} % vanaf het eerste overuur',
      tierAfter: '{percent} % na {hours} overuren',
      none: 'Geen regel',
      switchedOff: 'Regel geldt niet (uitgeschakeld)',
    },
    status: {
      statutory: 'Wettelijk',
      noStatutoryRule: 'Geen wettelijke regel',
      infoOnly: 'Alleen ter informatie',
      deviation: 'Afwijking',
      deviationStricter: 'Afwijking · strenger',
      deviationLooser: 'Afwijking · soepeler',
      deviationMoreFavourable: 'Afwijking · gunstiger dan de wet',
      deviationLessFavourable: 'Afwijking · ongunstiger dan de wet',
      deviationEqual: 'Afwijking · gelijk aan de wet',
      deviationMixed: 'Afwijking · deels strenger, deels soepeler',
      deviationMixedFavourable: 'Afwijking · deels gunstiger, deels ongunstiger',
    },
    hint: {
      stricter: 'Strenger dan de wet – met elke grondslag toegestaan.',
      looser: 'Soepeler dan de wet – hiervoor is een cao, een bedrijfsregeling of een ontheffing als grondslag nodig.',
      moreFavourable: 'Gunstiger dan de wet – met elke grondslag toegestaan.',
      lessFavourable: 'Ongunstiger dan de wet – hiervoor is een cao, een bedrijfsregeling of een ontheffing als grondslag nodig.',
      mixed: 'Deels strenger, deels soepeler dan de wet – hiervoor is een cao, een bedrijfsregeling of een ontheffing als grondslag nodig.',
      mixedFavourable: 'Deels gunstiger, deels ongunstiger dan de wet – hiervoor is een cao, een bedrijfsregeling of een ontheffing als grondslag nodig.',
      equal: 'Gelijk aan de wettelijke waarde – hiervoor is geen afwijking nodig.',
      incomparable: 'Bij deze regel bestaat geen ‘strenger’ of ‘soepeler’ – elke grondslag is mogelijk.',
      blocked: 'Bedrijfsbeleid mag niet onder de wet blijven. Kies een cao, een bedrijfsregeling of een ontheffing als grondslag – of een waarde die minstens aan de wet voldoet.',
    },
    table: {
      rule: 'Regel',
      applies: 'Geldt',
      note: 'Toelichting bij de wet',
      deviate: 'Afwijken',
      backToStatute: 'Terug naar de wet',
      statutoryWouldBe: 'Wettelijk zou gelden: {value}',
      statutoryWouldBeNone: 'De wet kent hier geen regel.',
      basis: 'Grondslag: {name}',
      basisWithClause: 'Grondslag: {name}, {clause}',
      coveredDeviation: 'Met cao-code {code}: {value} ({name})',
      futureDeviation: 'Vanaf {date}: {value} ({name})',
      fallbackApplies: 'De wet legt hier geen periode vast – deze geldt totdat een afspraak een andere vastlegt.',
      fallbackWouldBe: 'De wet legt hier geen periode vast – zonder de afwijking zou gelden: {value}',
      editDeviationOf: 'Afwijking van ‘{name}’ bewerken',
      backToStatuteOf: 'Afwijking van ‘{name}’ terug naar de wet',
    },
    notice: {
      fallback: 'De catalogus met wettelijke regels is tijdelijk niet bereikbaar. De meegeleverde basis wordt getoond; recente wijzigingen kunnen ontbreken.',
      unjudged: 'Personen voor wie nu geen wettelijke regel geldt: {count}. Ze hebben geen werklocatie en er is geen standaardrechtsgebied gekozen – kies er hieronder een.',
      upcoming: 'Vanaf {date} verandert de wettelijke regel ‘{rule}’ in: {value}.',
      upcomingNone: 'Vanaf {date} vervalt de wettelijke regel ‘{rule}’.',
      upcomingDeviationStays: 'Je afwijking blijft gelden.',
      reviewTitle: 'Controleer: {rule}',
      review: 'De wettelijke waarde is gewijzigd sinds deze afwijking is vastgelegd ({agreement}). Wettelijk geldt nu: {statutory}. Je afwijking: {deviation}.',
      keepDeviation: 'Afwijking behouden',
    },
    minors: {
      title: 'Jongeren onder de 18',
      headcount: 'Aantal personen: {count}',
      headcountNone: 'momenteel geen',
      hint: 'Voor personen onder de 18 gelden deze wettelijke jeugdbeschermingsregels in plaats van de algemene – automatisch, op basis van de geboortedatum in Personeel. Afspraken wijken hier niet van af.',
      generalApplies: 'Nog geen eigen regel – tot dan geldt de algemene.',
      upcoming: 'Vanaf {date}: {value}',
      upcomingNone: 'Vanaf {date} vervalt deze jeugdbeschermingsregel.',
    },
    form: {
      value: 'Afwijkende waarde',
      daysUnit: 'dagen',
      stageAfterHours: 'Arbeidstijd van meer dan (uur)',
      stageMinutes: 'Pauze in totaal (min)',
      tierAfterHours: 'Vanaf overuren per week (uur)',
      tierPercent: 'Toeslag (%)',
      addStep: 'Trede toevoegen',
      removeStep: 'Trede {row} verwijderen',
      stageAfterHoursRow: 'Trede {row}: arbeidstijd van meer dan (uur)',
      stageMinutesRow: 'Trede {row}: pauze in totaal (min)',
      tierAfterHoursRow: 'Trede {row}: vanaf overuren per week (uur)',
      tierPercentRow: 'Trede {row}: toeslag (%)',
      averageHours: 'Uren per week gemiddeld',
      averageWeeks: 'Referentieperiode (weken)',
      windowStart: 'Begin',
      windowEnd: 'Einde',
      windowHint: 'Ligt het einde vóór het begin, dan loopt het venster door na middernacht.',
      statutoryIs: 'Wettelijk geldt: {value}',
      comparisonBase: 'Zonder wettelijke regel geldt {value} – daaraan wordt de afwijking gemeten.',
      basis: 'Grondslag',
      basisHint: 'De afspraak waarop de afwijking berust.',
      basisPick: 'Grondslag kiezen…',
      basisNew: 'Nieuwe grondslag aanmaken…',
      basisRequired: 'Kies een grondslag.',
      clause: 'Vindplaats',
      clauseHint: 'Waar de bepaling staat, bijv. ‘art. 4 lid 2’. Optioneel.',
      invalid: {
        hours: 'Vul uren in: meer dan 0 en hoogstens 168.',
        days: 'Vul dagen in: meer dan 0 en hoogstens 366.',
        breakLadder: 'Controleer de treden: 1 tot 6 treden, oplopend naar arbeidstijd (meer dan 0 tot 24 uur), een pauze van meer dan 0 tot 480 min en nooit korter dan in de trede ervoor.',
        weeklyAverage: 'Controleer de waarden: uren meer dan 0 en hoogstens 168, referentieperiode 1 tot 104 weken.',
        timeWindow: 'Vul een begin- en eindtijd in; ze moeten verschillen.',
        percentTiers: 'Controleer de treden: 1 tot 6 treden, de eerste vanaf 0 overuren, de volgende oplopend; toeslag tussen 0 en 300 % met hoogstens twee decimalen.',
      },
    },
    agreement: {
      name: 'Naam',
      title: 'Afspraken',
      subtitle: 'Cao’s, bedrijfsregelingen, ontheffingen en bedrijfsbeleid – de grondslagen van je afwijkingen.',
      new: 'Nieuwe afspraak',
      edit: 'Afspraak bewerken',
      empty: 'Nog geen afspraken – overal gelden de wettelijke regels.',
      inactive: 'Momenteel niet geldig',
      migrated: 'Overgenomen uit eerdere instellingen',
      noDeviations: 'Nog geen afwijkingen. Leg ze hierboven vast bij de betreffende regel.',
      needsReview: 'Controleren',
      kind: 'Soort afspraak',
      companyPolicyHint: 'Bedrijfsbeleid mag alleen strenger of gunstiger zijn dan de wet.',
      nameHint: 'Bijvoorbeeld ‘Cao Metaal’ of ‘Pauzeregeling 2026’.',
      nameRequired: 'Geef de afspraak een naam.',
      reference: 'Kenmerk / nummer',
      referenceHint: 'Optioneel, bijv. registratienummer of beschikkingsnummer.',
      jurisdiction: 'Rechtsgebied',
      validFrom: 'Geldig vanaf',
      validFromRequired: 'Geef aan vanaf wanneer de afspraak geldt.',
      validTo: 'Geldig tot en met',
      validToHint: 'Leeg laten als de afspraak voor onbepaalde tijd geldt.',
      validSince: 'geldig vanaf {from}',
      validRange: 'geldig {from} – {to}',
      scope: 'Geldt voor',
      scopeAll: 'iedereen in dit rechtsgebied',
      scopeCovered: 'alleen personen die onder de cao vallen',
      scopeCoveredCode: 'alleen cao-code {code}',
      coverageCode: 'Cao-code',
      coverageCodeHint: 'De code wordt vastgelegd in het arbeidscontract van een persoon in Personeel. De afspraak geldt alleen voor personen met precies deze code.',
      deleteTitle: '‘{name}’ verwijderen?',
      deleteConfirm: 'Met de afspraak worden ook de afwijkingen ervan verwijderd (aantal: {count}). Voor die regels geldt daarna weer de wet.',
      deleteConfirmEmpty: 'De afspraak heeft geen afwijkingen; aan de geldende regels verandert niets.',
      editDeviation: 'Afwijking bewerken: {rule}',
      removeDeviation: 'Terug naar de wet: {rule}',
    },
    backConfirm: {
      title: '‘{rule}’: terug naar de wet?',
      body: 'De afwijking wordt verwijderd. Daarna geldt weer de wettelijke waarde: {value}.',
      bodyNone: 'De afwijking wordt verwijderd. De wet kent hier geen regel – daarna geldt er geen meer.',
      bodyFallback: 'De afwijking wordt verwijderd. De wet kent hier geen regel – daarna geldt weer {value}.',
    },
    workspace: {
      title: 'Instellingen van de workspace',
      defaultJurisdiction: 'Standaardrechtsgebied',
      defaultJurisdictionHint: 'Geldt voor personen zonder werklocatie of met een werklocatie die de catalogus niet dekt.',
      noDefault: 'Geen standaard',
      mode: 'Als een boeking een regel overtreedt',
      modeFlexible: 'Waarschuwen en vastleggen',
      modeFlexibleHint: 'De boeking wordt opgeslagen. De overtreding wordt getoond en vastgelegd.',
      modeStrict: 'Boeking blokkeren',
      modeStrictHint: 'Een boeking die een afgedwongen regel overtreedt, kan niet worden opgeslagen.',
      originSignup: 'Overgenomen uit het land dat je bedrijf bij de registratie heeft opgegeven: {country}.',
      originFallbackPrevious: 'Totdat het land dat je bedrijf bij de registratie heeft opgegeven bekend is en in de catalogus staat, gelden de regels van {current} – de regels waarnaar deze werkruimte tot nu toe werd beoordeeld.',
      originFallbackUnknown: 'Het land van je bedrijf is nog niet bekend. Daarom geldt het EU-minimum totdat iemand hier het land kiest.',
      originFallbackUncovered: 'Bij de registratie heeft je bedrijf {country} opgegeven. De catalogus bevat daarvoor nog geen regels, daarom geldt het EU-minimum.',
      originFallbackCovered: 'Bij de registratie heeft je bedrijf {country} opgegeven; de regels daarvan staan inmiddels in de catalogus. Kies het hier om ze toe te passen – tot dan geldt het EU-minimum.',
    },
    toast: {
      settingsSaved: 'Instellingen opgeslagen',
      deviationSaved: 'Afwijking opgeslagen',
      deviationConfirmed: 'Afwijking bevestigd',
      backToStatute: 'Afwijking verwijderd – de wet geldt weer',
      agreementSaved: 'Afspraak opgeslagen',
      agreementDeleted: 'Afspraak verwijderd',
      modelsCreated: 'Aangemaakte werktijdmodellen: {count}',
      modelsExist: 'De werktijdmodellen van dit land bestaan al.',
    },
    errors: {
      rival: '‘{name}’ legt deze regel al vast voor dezelfde personen in een overlappende periode.',
      validToBeforeFrom: 'Het einde van de geldigheid mag niet vóór het begin liggen.',
      coverageCodeRequired: 'Vul de cao-code in waarvoor de afspraak geldt.',
      invalidValue: 'De waarde is niet geldig voor deze regel. Controleer deze.',
      jurisdictionUnknown: 'Dit rechtsgebied staat niet in de catalogus met wettelijke regels.',
      dateInvalid: 'Vul een geldige datum in.',
      labelInvalid: 'Controleer de tekstvelden: de naam is verplicht en geen veld mag langer zijn dan 160 tekens.',
      noModelPresets: 'Voor dit land zijn er geen voorbereide werktijdmodellen.',
      kindInvalid: 'Kies het soort afspraak uit de lijst.',
      modeInvalid: 'Kies wat er gebeurt als een boeking een regel overtreedt.',
      ruleUnknown: 'Deze versie van de app kent deze regel niet. Laad de pagina opnieuw.',
      ruleInfoOnly: 'Deze regel wordt alleen ter informatie getoond – je kunt er niet van afwijken.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Tijd is niet actief in deze werkruimte',
      timeInactive: 'De wettelijke regels gelden voor de werktijd die in Tijd wordt geregistreerd. Zodra Tijd deel uitmaakt van deze werkruimte, leg je hier vast waar je bedrijf ervan afwijkt.',
      noAccess: 'Je kunt de wettelijke regels van deze werkruimte niet beheren. Dat kunnen de eigenaar van de werkruimte, de suite-beheerders en leden van Tijd met de bevoegdheid om naleving te beheren.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Opleidingsberoepen',
    columns: {
      occupation: 'Opleidingsberoep',
      duration: 'Duur',
      regulation: 'Opleidingsregeling',
      apprentices: 'Leerlingen',
    },
    duration: '{count} maanden',
    regulationIssued: 'van {date}',
    regulationValidFrom: 'van kracht sinds {date}',
    areas: {
      IH: 'Industrie en handel (IHK)',
      Hw: 'Ambacht (HWK)',
      oeD: 'Openbare dienst',
      Lw: 'Landbouw',
      FB: 'Vrije beroepen',
      Hausw: 'Huishoudkunde',
      See: 'Zeevaart',
    },
    branches: {
      specialisations: 'Specialisaties',
      focuses: 'Zwaartepunten',
      any: 'Specialisaties / zwaartepunten',
    },
    requirements: {
      onWall: 'Posities uit de opleidingsregeling op de vaardighedenmuur: {count}',
      version: 'regeling van {date}',
      none: 'De posities uit de opleidingsregeling zijn nog niet beschikbaar. Ze verschijnen op de vaardighedenmuur zodra de platformbeheerder ze heeft geïmporteerd.',
      versions: 'Leerlingen worden opgeleid volgens {count} versies van de regeling – voor ieder blijft de versie gelden die bij de start van de opleiding van kracht was.',
    },
    state: {
      notSelectable: 'Niet meer te kiezen',
      notSelectableHint: 'De platformbeheerder biedt dit beroep niet meer aan voor nieuwe selectie. Je werkruimte behoudt het, met de leerlingen erin – maar als je het verwijdert, kan het niet opnieuw worden toegevoegd.',
      withdrawn: 'Erkenning ingetrokken',
      withdrawnHint: 'De staatserkenning van dit beroep is ingetrokken, of het staat niet meer in het register van erkende opleidingsberoepen. Lopende opleidingen worden afgemaakt; het kan niet opnieuw worden toegevoegd.',
      unknown: 'Niet in de catalogus',
      unknownHint: 'Deze invoer is getypt voordat de catalogus bestond en komt met geen van de beroepen daarin overeen. Je kunt hem alleen verwijderen – voeg in plaats daarvan het passende beroep uit de catalogus toe.',
    },
    offered: {
      title: 'Ons aanbod',
      intro: 'De erkende opleidingsberoepen waarin je bedrijf opleidt. Alleen deze kunnen voor een leerling worden gekozen.',
      emptyTitle: 'Nog geen opleidingsberoep in het aanbod',
      empty: 'Kies in de catalogus hieronder de beroepen waarin je bedrijf opleidt. Daarna kun je ze aan je leerlingen toewijzen.',
      browse: 'Uit de catalogus kiezen',
      remove: 'Verwijderen',
      removeNamed: '{title} uit het aanbod verwijderen',
    },
    catalogue: {
      title: 'Toevoegen uit de catalogus',
      intro: 'De in Duitsland erkende opleidingsberoepen die je werkruimte nog niet aanbiedt. De catalogus wordt centraal actueel gehouden.',
      unavailableTitle: 'De catalogus is op dit moment niet bereikbaar',
      unavailable: 'Je aanbod hierboven wordt getoond op basis van wat deze werkruimte heeft opgeslagen. Beroepen kunnen weer worden toegevoegd zodra de catalogus terug is.',
      allOffered: 'Je werkruimte biedt al alle beroepen uit de catalogus aan.',
      searchPlaceholder: 'Titel of specialisatie',
      areaLabel: 'Sector',
      areaAll: 'Alle sectoren',
      count: 'Gevonden beroepen: {shown} van {total}',
      noMatches: 'Geen beroep komt overeen met je zoekopdracht.',
      resetFilters: 'Zoekopdracht wissen',
      showMore: 'Meer tonen',
      add: 'Toevoegen',
      addNamed: '{title} aan het aanbod toevoegen',
    },
    removeConfirm: {
      title: '‘{title}’ uit het aanbod verwijderen?',
      apprentices: 'Leerlingen die nu aan dit beroep zijn gekoppeld: {count}. Zij behouden hun beroep en maken hun opleiding af – het kan alleen niet meer voor nieuwe leerlingen worden gekozen.',
      final: 'Eenmaal verwijderd kan dit beroep niet opnieuw worden toegevoegd.',
      confirm: 'Uit het aanbod verwijderen',
    },
    toast: {
      added: '‘{title}’ hoort nu bij je aanbod',
      removed: '‘{title}’ wordt niet meer aangeboden',
    },
    errors: {
      notOfferable: '‘{title}’ kon niet worden toegevoegd: het beroep is intussen uitgeschakeld of ingetrokken. De lijst is bijgewerkt.',
      catalogueUnavailable: 'De catalogus is op dit moment niet bereikbaar, dus er kan niets worden toegevoegd. Probeer het later opnieuw.',
    },
    page: {
      moduleInactiveTitle: 'Opleiding is niet actief in deze werkruimte',
      moduleInactive: 'Opleidingsberoepen worden aangeboden voor de leerlingen die in de module Opleiding worden beheerd. Zodra die deel uitmaakt van deze werkruimte, kies je hier in welke beroepen je bedrijf opleidt.',
      noAccess: 'Je kunt de opleidingsberoepen van deze werkruimte niet beheren. Dat kunnen de eigenaar van de werkruimte, de suite-beheerders en leden van de module Opleiding met de bevoegdheid om die te beheren.',
    },
  },
};
